/*
  Produkt-Designer (Spreadshirt-Layout)
  Braucht fabric.js 5.x (assets/fabric.min.js).

  Koordinaten: Die Leinwand liegt über dem ganzen Produktbild. Intern ist das
  Produktbild immer 1000 Einheiten breit, die Höhe folgt dem Seitenverhältnis.
  Der Druckbereich ist ein Rechteck in diesen Einheiten. Beim Export wird genau
  dieser Bereich in Druckauflösung ausgeschnitten.

  Ansicht drehen: Die ganze Bühne (Produktbild, Druckbereich, Leinwand) wird
  per CSS um 90° gedreht. Die Objekte bleiben in Produktkoordinaten, darum
  sind Druckdateien und Vorschau von der Drehung nicht betroffen. Die
  Mauskoordinaten rechnet getPointer passend zurück.
*/
(function () {
  'use strict';

  var LOGICAL_W = 1000;
  var PROPS = ['pdKind', 'pdNatW', 'pdName', 'pdCurve', 'pdColor', 'pdGroup', 'pdBg'];
  var RED = '#e53935';
  var BLUE = '#2f6fed';
  var FONTS = [
    'Inter', 'Roboto', 'Montserrat', 'Poppins', 'Oswald', 'Anton', 'Bebas Neue', 'Archivo Black',
    'Teko', 'Staatliches', 'Russo One', 'Black Ops One', 'Graduate', 'Bangers', 'Righteous',
    'Abril Fatface', 'Roboto Slab', 'Merriweather', 'Playfair Display', 'Permanent Marker',
    'Pacifico', 'Lobster', 'Caveat', 'Dancing Script', 'Great Vibes', 'Press Start 2P'
  ];
  var PALETTE = [
    '#000000', '#ffffff', '#808080', '#c8c8c8', '#3a3a3a', '#d4af37',
    '#e53935', '#b71c1c', '#ff7043', '#ff9800', '#ffc107', '#ffeb3b',
    '#cddc39', '#7cb342', '#2e7d32', '#00897b', '#00bcd4', '#03a9f4',
    '#1e88e5', '#1a237e', '#5e35b1', '#8e24aa', '#d81b60', '#f48fb1', '#795548'
  ];
  // Textvorlagen: jede Zeile wird ein eigener Text, size ist relativ zur Grundhöhe
  var TEMPLATES = [
    { name: 'Team', lines: [{ text: 'TEAMNAME', font: 'Graduate', size: 0.9, curve: 35 }, { text: '10', font: 'Graduate', size: 3 }, { text: 'MÜLLER', font: 'Graduate', size: 0.8 }] },
    { name: 'Firma', lines: [{ text: 'FIRMENNAME', font: 'Montserrat', bold: true, size: 1 }, { text: 'Qualität aus Leidenschaft', font: 'Montserrat', size: 0.42 }] },
    { name: 'Verein', lines: [{ text: 'FC MUSTERSTADT', font: 'Staatliches', size: 1, curve: 45 }, { text: 'SEIT 1920', font: 'Staatliches', size: 0.55, spacing: 200 }] },
    { name: 'Event', lines: [{ text: 'JGA', font: 'Bangers', size: 2 }, { text: 'Mallorca 2026', font: 'Pacifico', size: 0.75 }] },
    { name: 'Crew', lines: [{ text: 'CREW', font: 'Black Ops One', size: 1.8 }, { text: 'Abi 2026', font: 'Permanent Marker', size: 0.8 }] },
    { name: 'Est.', lines: [{ text: 'EST. 2026', font: 'Oswald', size: 0.45, spacing: 400 }, { text: 'FAMILIE', font: 'Playfair Display', bold: true, size: 1.3 }, { text: 'SCHMIDT', font: 'Oswald', size: 0.6, spacing: 300 }] },
    { name: 'Geburtstag', lines: [{ text: 'Happy Birthday', font: 'Great Vibes', size: 1 }, { text: '50', font: 'Archivo Black', size: 2.4 }] },
    { name: 'Arbeit', lines: [{ text: 'MUSTERMANN GMBH', font: 'Archivo Black', size: 0.8 }, { text: 'Elektrotechnik', font: 'Inter', size: 0.5 }, { text: 'Tel. 0123 456789', font: 'Inter', size: 0.4 }] }
  ];
  var STORE_KEY = 'pd-design-v1';
  var DEFAULT_VIEW = { name: 'Vorne', match: 'vorne', x: 31, y: 24, w: 38, cm_w: 30, cm_h: 40 };
  var MAX_FILE_BYTES = 19 * 1024 * 1024;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function lc(s) { return String(s || '').toLowerCase(); }
  function round1(n) { return (Math.round(n * 10) / 10).toFixed(1).replace('.', ','); }

  // Text auf einem Kreisbogen. Der Pfad bekommt zusätzliche Punkte, damit der
  // Rahmen um den Text auch die Buchstabenhöhe einschließt.
  function applyCurve(t) {
    var c = +t.pdCurve || 0;
    t.set('path', null);
    t.initDimensions();
    if (!c) { t.setCoords(); return; }
    var w = Math.max(t.width, 1);
    var theta = Math.max(0.05, Math.abs(c) / 100 * 1.6 * Math.PI);
    // etwas länger als der Text, sonst springt der erste Buchstabe ans Ende
    var r = w * 1.04 / theta;
    var half = theta / 2;
    var up = c > 0;
    var asc = t.fontSize * 0.78, desc = t.fontSize * 0.22;
    function pt(a, R) { return up ? [R * Math.sin(a), r - R * Math.cos(a)] : [R * Math.sin(a), -r + R * Math.cos(a)]; }
    var top = up ? r + asc : r - asc;
    var bottom = up ? r - desc : r + desc;
    var angles = [-half, -half / 2, 0, half / 2, half];
    if (half > Math.PI / 2) angles.push(-Math.PI / 2, Math.PI / 2);
    // Der Bogen muss zuerst kommen, fabric misst die Buchstaben ab dem ersten Punkt
    var s = pt(-half, r), e = pt(half, r);
    var d = 'M ' + s[0].toFixed(2) + ' ' + s[1].toFixed(2) + ' A ' + r.toFixed(2) + ' ' + r.toFixed(2) + ' 0 ' +
      (theta > Math.PI ? 1 : 0) + ' ' + (up ? 1 : 0) + ' ' + e[0].toFixed(2) + ' ' + e[1].toFixed(2);
    angles.forEach(function (a) {
      [top, bottom].forEach(function (R) { var p = pt(a, R); d += ' M ' + p[0].toFixed(2) + ' ' + p[1].toFixed(2); });
    });
    t.set('path', new fabric.Path(d, { fill: '', stroke: '', strokeWidth: 0, objectCaching: false }));
    t.initDimensions();
    t.setCoords();
  }

  function fixCurves(objs) {
    objs.forEach(function (o) { if (o.pdCurve) applyCurve(o); });
  }

  // JSON ohne Textpfad, der wird beim Laden aus pdCurve neu gebaut.
  // Nur bei Texten: bei Vektorformen (fabric.Path) ist "path" die Form selbst.
  function stripTextPath(j) {
    if (j.type === 'i-text' || j.type === 'text' || j.type === 'textbox') delete j.path;
    return j;
  }
  function objectJson(o) {
    return stripTextPath(o.toObject(PROPS));
  }

  function serialize(canvas) {
    // Bei Mehrfachauswahl liefert fabric die echten Positionen nur über toObject der Leinwand
    var a = canvas.getActiveObject && canvas.getActiveObject();
    if (a && a.type === 'activeSelection') {
      return canvas.toObject(PROPS).objects.map(stripTextPath);
    }
    return canvas.getObjects().map(objectJson);
  }

  // Ein Motiv ist ein einzelnes Objekt oder eine ganze Vorlage (gleiche pdGroup)
  function unitOf(o, i) { return o.pdGroup || ('o' + i); }
  function countUnits(objs) {
    var seen = {};
    (objs || []).forEach(function (o, i) { seen[unitOf(o, i)] = 1; });
    return Object.keys(seen).length;
  }
  function hits(a, b) {
    return a.intersectsWithObject(b, true, true) || a.isContainedWithinObject(b, true, true) || b.isContainedWithinObject(a, true, true);
  }
  // Alle Objekte, die ein Objekt eines anderen Motivs berühren
  function overlapping(objs) {
    var bad = [];
    for (var i = 0; i < objs.length; i++) {
      for (var j = i + 1; j < objs.length; j++) {
        if (unitOf(objs[i], i) === unitOf(objs[j], j)) continue;
        if (hits(objs[i], objs[j])) {
          if (bad.indexOf(objs[i]) === -1) bad.push(objs[i]);
          if (bad.indexOf(objs[j]) === -1) bad.push(objs[j]);
        }
      }
    }
    return bad;
  }

  // Design als kurzen Text für den Teilen-Link packen (deflate + base64url)
  function b64url(bytes) {
    var s = '';
    for (var i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function unb64url(str) {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    var bin = atob(str), out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }
  function pipeBytes(bytes, stream) {
    return new Response(new Blob([bytes]).stream().pipeThrough(stream)).arrayBuffer().then(function (b) { return new Uint8Array(b); });
  }
  function packDesign(obj) {
    var raw = new TextEncoder().encode(JSON.stringify(obj));
    if (!window.CompressionStream) return Promise.resolve('j' + b64url(raw));
    return pipeBytes(raw, new CompressionStream('deflate-raw')).then(function (z) { return 'z' + b64url(z); });
  }
  function unpackDesign(code) {
    var bytes = unb64url(code.slice(1));
    var p = code.charAt(0) === 'z' ? pipeBytes(bytes, new DecompressionStream('deflate-raw')) : Promise.resolve(bytes);
    return p.then(function (b) { return JSON.parse(new TextDecoder().decode(b)); });
  }

  function whenFabric(cb) {
    if (window.fabric) return cb();
    var tries = 0;
    var t = setInterval(function () {
      if (window.fabric || ++tries > 200) { clearInterval(t); if (window.fabric) cb(); }
    }, 50);
  }

  function Designer(root) {
    this.root = root;
    this.data = JSON.parse($(root, '[data-pd-product]').textContent);
    this.colorIdx = (parseInt(root.dataset.colorIndex, 10) || 0) - 1;
    this.sizeIdx = (parseInt(root.dataset.sizeIndex, 10) || 0) - 1;
    this.dpi = parseInt(root.dataset.printDpi, 10) || 300;
    this.maxUploadMb = parseInt(root.dataset.maxUploadMb, 10) || 10;
    this.moneyFormat = root.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
    this.form = document.getElementById(root.dataset.formId);
    this.zoom = 1;
    this.viewRot = 0;            // Drehung der Ansicht in Grad (0, 90, 180, 270), nur Bildschirm
    this.designs = {};
    this.history = {};
    this.uploads = [];
    this.overlapViews = {};
    this.extraMotifCents = parseInt(root.dataset.extraMotifCents, 10) || 0;
    this.extraMotifVariant = root.dataset.extraMotifVariant || '';
    this.fileCheckCents = parseInt(root.dataset.fileCheckCents, 10) || 0;
    this.fileCheckVariant = root.dataset.fileCheckVariant || '';
    this.reworkCents = parseInt(root.dataset.reworkCents, 10) || 0;
    this.reworkVariant = root.dataset.reworkVariant || '';
    this.service = '';           // '' | 'check' (Datei-Check) | 'rework' (Logo-Überarbeitung)
    this.fileCheckAsked = false; // Nachfrage vor dem Warenkorb schon beantwortet
    this.loading = false;
    this.views = (Array.isArray(this.data.views) && this.data.views.length ? this.data.views : [DEFAULT_VIEW]).map(function (v) {
      var ro = !!(v.nur_ansicht || v.readonly);
      return {
        name: v.name || 'Vorne',
        match: lc(v.match || v.name),
        x: ro ? 0 : +v.x, y: ro ? 0 : +v.y, w: ro ? 100 : +v.w,
        cm_w: ro ? 1 : (+v.cm_w || 30), cm_h: ro ? 1 : (+v.cm_h || 40),
        readonly: ro,
        img: v.img && v.img.src ? v.img : null
      };
    });

    var first = this.firstVariant();
    this.selColor = this.colorIdx >= 0 && first ? first.options[this.colorIdx] : null;
    this.selSize = null;
    this.viewIndex = 0;

    this.setupCanvas();
    this.renderToolbarLists();
    this.renderTemplates();
    this.bindUi();
    this.renderSwatches();
    this.renderSizes();
    this.restore();
    this.renderViews();
    this.showView(Math.max(0, this.firstEditable()), true);
    this.updateVariant();
    this.updateDelivery();
  }

  var P = Designer.prototype;

  /* ---------- Varianten ---------- */

  P.firstVariant = function () {
    var vs = this.data.variants;
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return vs[0];
  };

  P.optionValues = function (idx) {
    var seen = {}, out = [];
    this.data.variants.forEach(function (v) {
      var val = v.options[idx];
      if (val != null && !seen[val]) { seen[val] = 1; out.push(val); }
    });
    return out;
  };

  P.findVariant = function (size) {
    var self = this;
    var base = this.currentVariantGuess || this.firstVariant();
    var list = this.data.variants.filter(function (v) {
      if (self.colorIdx >= 0 && v.options[self.colorIdx] !== self.selColor) return false;
      if (self.sizeIdx >= 0 && size != null && v.options[self.sizeIdx] !== size) return false;
      for (var k = 0; k < 3; k++) {
        if (k === self.colorIdx || k === self.sizeIdx) continue;
        if (base && v.options[k] !== base.options[k]) return false;
      }
      return true;
    });
    for (var i = 0; i < list.length; i++) if (list[i].available) return list[i];
    return list[0] || null;
  };

  P.currentVariant = function () {
    return this.findVariant(this.sizeIdx >= 0 ? this.selSize : null);
  };

  P.updateVariant = function () {
    var v = this.currentVariant();
    if (!v) return;
    this.currentVariantGuess = v;
    var input = $(this.root, '[data-pd-variant-input]');
    if (input) input.value = v.id;
    this.renderTotal();
    var detail = { variant: v, sectionId: this.root.dataset.sectionId };
    document.dispatchEvent(new CustomEvent('variant:change', { detail: detail }));
  };

  P.formatMoney = function (cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return this.moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, whole + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/g, parts[0] + '.' + parts[1]);
  };

  /* ---------- Farbe ---------- */

  /* Farbtöne für Farben ohne eigenes Swatch (deutsche Namen, Cotton Classics) */
  var PD_HEX = {"Weiß":"#ffffff","Schwarz":"#1c1c1c","Hellgrau":"#c9c9c9","Limettengrün":"#9acd32","Royalblau":"#1f4fbf","Kiwi":"#8ab43a","Senfgelb":"#d4a017","Violett":"#6a3d9a","Apfelgrün":"#7cc242","Natur":"#efe6d2","Lavendel":"#b7a6d9","Sand":"#d8c6a0","Schokobraun":"#4b2e20","Gelb":"#f5d000","Rot":"#d7182a","Orange":"#f26b1d","Pink":"#f2a1c0","Klassikrot":"#b5121b","Koralle":"#f2735e","Smaragdgrün":"#009b77","Navy":"#1d2a4d","Fuchsia":"#d0006f","Zitronengelb":"#f7e84a","Lila":"#5b2a86","Burgunder":"#6d1a2b","Himmelblau":"#8cc8ec","Kräftiges Pink":"#e8418c","Mint":"#98e0c2","Kellygrün":"#1f9a3e","Flaschengrün":"#1e4d2b","Pflaume":"#5e2750","Petrol":"#0e5c6b","Sonnenblumengelb":"#f5b400","Magenta":"#c2185b","Olivgrün":"#6b6b2a","Reingrau":"#9a9a9a","Karamell":"#b5753a","Kornblumenblau":"#5f7fd6","Cranberry":"#9b1b3d","Graphitgrau":"#4a4a4f","Saphirblau":"#0f52ba","Surfblau":"#2a8fbf","Rostorange":"#b7471b","Graublau":"#5d7a99","Pastellblau":"#b5d3ec","Pastellrosa":"#f6c9d4","Pastellmint":"#c6ecd9","Himbeerpink":"#d6336c","Hellgrau/Schwarz":"linear-gradient(135deg,#c9c9c9 50%,#1c1c1c 50%)","Biskuit/Schwarz":"linear-gradient(135deg,#c9b58f 50%,#1c1c1c 50%)","Walnuss/Schwarz":"linear-gradient(135deg,#5a3e2b 50%,#1c1c1c 50%)","Graphitgrau/Schwarz":"linear-gradient(135deg,#4a4a4f 50%,#1c1c1c 50%)","Militärgrün/Schwarz":"linear-gradient(135deg,#4b5a32 50%,#1c1c1c 50%)","Haferbeige/Schwarz":"linear-gradient(135deg,#d8ccb4 50%,#1c1c1c 50%)","Oxford Navy/Schwarz":"linear-gradient(135deg,#26324f 50%,#1c1c1c 50%)","Schwarz/Gelb":"linear-gradient(135deg,#1c1c1c 50%,#f5d000 50%)","Schwarz/Hellgrau":"linear-gradient(135deg,#1c1c1c 50%,#c9c9c9 50%)","Schwarz/Orange":"linear-gradient(135deg,#1c1c1c 50%,#f26b1d 50%)","Schwarz/Weiß":"linear-gradient(135deg,#1c1c1c 50%,#ffffff 50%)","Navy/Weiß":"linear-gradient(135deg,#1d2a4d 50%,#ffffff 50%)","Schwarz/Limettengrün":"linear-gradient(135deg,#1c1c1c 50%,#9acd32 50%)","Schwarz/Fuchsia":"linear-gradient(135deg,#1c1c1c 50%,#d0006f 50%)","Olivgrün/Schwarz":"linear-gradient(135deg,#6b6b2a 50%,#1c1c1c 50%)","Schwarz/Klassikrot":"linear-gradient(135deg,#1c1c1c 50%,#b5121b 50%)","Royalblau/Weiß":"linear-gradient(135deg,#1f4fbf 50%,#ffffff 50%)","Klassikrot/Weiß":"linear-gradient(135deg,#b5121b 50%,#ffffff 50%)","Schwarz/Surfblau":"linear-gradient(135deg,#1c1c1c 50%,#2a8fbf 50%)","Burgunder/Hellgrau":"linear-gradient(135deg,#6d1a2b 50%,#c9c9c9 50%)","Schokobraun/Karamell":"linear-gradient(135deg,#4b2e20 50%,#b5753a 50%)","Grün/Weiß":"linear-gradient(135deg,#21a14b 50%,#ffffff 50%)","Militärgrün":"#4b5a32","Grau meliert/Schwarz":"linear-gradient(135deg,#9c9c9c 50%,#1c1c1c 50%)","Off-White":"#f4f1e8","Dunkelgrau":"#4d4d4f","Asche":"#c8c8c4","Creme":"#f1e8cf","Khaki":"#8a7f5a","Goldgelb":"#f2b01e","Orchideenpink":"#e7a3c9","Bonbonrosa":"#f4a7c4","Dunkellila":"#3f1e5a","Helllila":"#b49ad8","Aqua":"#4fc3d9","Asphaltgrau":"#7c7f83","Beige":"#d4c4a8","Retrogrün":"#4f8a5b","Grasgrün":"#4caf3a","Pastellgelb":"#f8e79b","Moosgrün hell":"#b5c49a","Hibiskuspink":"#e5487a","Rosa":"#f3c6cf","Flieder":"#c4a8d8","Baltikblau":"#2f5d8a","Puderblau":"#a9c8e4","Kräftiges Blau":"#1a5fd0","Vintageblau":"#6d8fb0","Hellnavy":"#2c3e6b","Beryllblau":"#5a8fb0","Grau meliert":"#a9a9a9","Scharlachrot":"#c8102e","Mitternachtsblau":"#1b2238","Bordeaux":"#5e1a26","Schiefergrau":"#5f6770","Marineblau":"#1d4f8a","Grau":"#7a7a7a","Waldgrün":"#214d33","Sportgrau":"#9fa1a3","Seeblau":"#3a7fc0","Neonlimette":"#c6e33a","Weinrot":"#5c1a2e","Limette":"#a8d02c","Türkisblau":"#1aa3c9","Navy meliert":"#3a4561","Camel meliert":"#b08d64","Hellblau meliert":"#9fb4c8","Grün meliert":"#5f7a63","Anthrazit":"#3e3f42","Dunkelnavy":"#161d33","Tannengrün":"#25463a","Armygrün":"#4b5320","Paprikarot":"#c0272d","Blau":"#1f5fbf","Dunkelkhaki":"#7a6a4a","Zink":"#8a8d8f","Atollblau":"#2aa3c4","Karibikblau":"#00a6b8","Erdbraun":"#6b4f3a","French Navy":"#1d2540","Mausgrau":"#8c8a86","Eisblau":"#bcd9ea","Denim":"#3b5878","Tangorot":"#d4352b","Chilirot":"#a3231f","Reinweiß":"#fdfdfd","Folkrot":"#c0262d","Hanf":"#c9b28a","Terrakotta":"#c0603f","Ultramarin":"#2a3fa0","Salbeigrün":"#9caf88","Hibiskus":"#d6336c","Petrolblau":"#1f5a6b","Altrosa":"#d8a6a6","Grün":"#2e7d32","Kobaltblau":"#1f4fa8","Oliv":"#5f6b3a","Nasser Sand":"#b49c7c","Baumrinde":"#5a4636","Nachtlila":"#3b2a4f","Kirschrot":"#8e1b2c","Abendrosa":"#c99a9a","Salbei":"#a7b59a","Rohweiß":"#f3efe6","Magnetgrau":"#4a4c4f","Violablau":"#5b5fa8","Altorange":"#d98a4e","Naturweiß":"#f7f4ec","Wolkengrau":"#c7c9cb","Dunkelblau":"#1c2b4a","Bernstein":"#d9902a","Ziegelrot":"#b0332a","Toffee":"#8a5a3a"};
  /* Hauptfarben: werden immer direkt gezeigt, je Eintrag Ersatznamen, falls ein Produkt die Farbe nicht hat */
  var PD_MAIN = [
    ['Weiß'], ['Schwarz'], ['Grau meliert', 'Sportgrau', 'Grau', 'Hellgrau'],
    ['Dunkelgrau', 'Anthrazit', 'Graphitgrau', 'Schiefergrau'], ['Navy', 'Dunkelnavy', 'Mitternachtsblau'],
    ['Royalblau'], ['Rot', 'Scharlachrot', 'Klassikrot', 'Paprikarot'], ['Bordeaux', 'Burgunder', 'Weinrot'],
    ['Flaschengrün', 'Waldgrün', 'Tannengrün', 'Kellygrün'], ['Natur', 'Creme', 'Off-White', 'Sand', 'Beige']
  ];
  var PD_MAX = 10;

  P.colorSplit = function () {
    var all = this.optionValues(this.colorIdx);
    if (all.length <= PD_MAX) return { main: all, more: [] };
    var main = [];
    PD_MAIN.forEach(function (alts) {
      for (var i = 0; i < alts.length; i++) {
        if (all.indexOf(alts[i]) > -1 && main.indexOf(alts[i]) < 0) { main.push(alts[i]); return; }
      }
    });
    for (var i = 0; i < all.length && main.length < PD_MAX; i++) {
      if (main.indexOf(all[i]) < 0) main.push(all[i]);
    }
    main.sort(function (x, y) { return all.indexOf(x) - all.indexOf(y); });
    return { main: main, more: all.filter(function (v) { return main.indexOf(v) < 0; }) };
  };

  P.swatchButton = function (val, withName) {
    var self = this, thumb = null, available = false;
    this.data.variants.forEach(function (v) {
      if (v.options[self.colorIdx] !== val) return;
      if (!thumb && v.thumb) thumb = v.thumb;
      if (v.available) available = true;
    });
    var front = this.imageFor(this.views[0], val, true);
    if (front) thumb = front.thumb || thumb;
    var sw = (this.data.swatches || {})[val] || PD_HEX[val];
    var b = document.createElement('button');
    b.type = 'button';
    b.className = (withName ? 'pd__cm-item' : 'pd__swatch') + (val === this.selColor ? ' is-active' : '') + (available ? '' : ' is-soldout');
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', val === this.selColor ? 'true' : 'false');
    b.setAttribute('aria-label', val);
    b.title = val;
    if (thumb && !withName) {
      var img = document.createElement('img');
      img.src = thumb; img.alt = ''; img.loading = 'lazy';
      b.appendChild(img);
    } else {
      var dot = document.createElement('span');
      dot.className = 'pd__swatch-dot';
      if (sw && /^(https?:)?\/\//.test(sw)) dot.style.backgroundImage = 'url(' + sw + ')';
      else dot.style.background = sw || '#ccc';
      b.appendChild(dot);
    }
    if (withName) {
      var n = document.createElement('span');
      n.className = 'pd__cm-name';
      n.textContent = val;
      b.appendChild(n);
    }
    return b;
  };

  P.renderSwatches = function () {
    var wrap = $(this.root, '[data-pd-swatches]');
    if (!wrap || this.colorIdx < 0) return;
    var self = this;
    var split = this.colorSplit();
    var shown = split.main.slice();
    if (this.selColor && shown.indexOf(this.selColor) < 0) shown.push(this.selColor);
    wrap.innerHTML = '';
    shown.forEach(function (val) {
      var b = self.swatchButton(val, false);
      b.addEventListener('click', function () { self.setColor(val); });
      wrap.appendChild(b);
    });
    var holder = $(this.root, '[data-pd-more-colors]');
    if (holder) holder.remove();
    if (!split.more.length) return;
    holder = document.createElement('div');
    holder.setAttribute('data-pd-more-colors', '');
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'pd__more-colors';
    more.innerHTML = '<span class="pd__more-dots" aria-hidden="true"></span><span>Andere Farbe auswählen</span><span class="pd__more-count">+' + split.more.length + '</span>';
    more.addEventListener('click', function () { self.openColorModal(); });
    holder.appendChild(more);
    wrap.parentNode.insertBefore(holder, wrap.nextSibling);
  };

  P.openColorModal = function () {
    var self = this;
    var all = this.optionValues(this.colorIdx);
    var split = this.colorSplit();
    var m = document.createElement('div');
    m.className = 'pd__cm';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Farbe auswählen');
    m.innerHTML = '<div class="pd__cm-back" data-cm-close></div><div class="pd__cm-box">'
      + '<div class="pd__cm-head"><p class="pd__cm-title">Farbe auswählen</p><span class="pd__cm-sub">' + all.length + ' Farben</span>'
      + '<button type="button" class="pd__cm-x" data-cm-close aria-label="Schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>'
      + '<div class="pd__cm-body"><p class="pd__cm-group">Beliebte Farben</p><div class="pd__cm-grid" data-cm-main role="radiogroup" aria-label="Beliebte Farben"></div>'
      + '<p class="pd__cm-group">Weitere Farben</p><div class="pd__cm-grid" data-cm-more role="radiogroup" aria-label="Weitere Farben"></div></div></div>';
    function fill(sel, list) {
      var g = m.querySelector(sel);
      list.forEach(function (val) {
        var b = self.swatchButton(val, true);
        b.addEventListener('click', function () { close(); self.setColor(val); });
        g.appendChild(b);
      });
    }
    fill('[data-cm-main]', split.main);
    fill('[data-cm-more]', split.more);
    var last = document.activeElement;
    function key(e) { if (e.key === 'Escape') close(); }
    function close() {
      document.removeEventListener('keydown', key);
      document.documentElement.classList.remove('pd-cm-open');
      m.remove();
      if (last && last.focus) last.focus();
    }
    m.querySelectorAll('[data-cm-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', key);
    document.body.appendChild(m);
    document.documentElement.classList.add('pd-cm-open');
    var act = m.querySelector('.pd__cm-item.is-active') || m.querySelector('.pd__cm-x');
    if (act) act.focus();
  };

  P.setColor = function (val) {
    this.selColor = val;
    var name = $(this.root, '[data-pd-color-name]');
    if (name) name.textContent = val;
    this.renderSwatches();
    this.renderSizes();
    this.updateVariant();
    this.renderViews();
    this.setMockupImage();
  };

  /* ---------- Größe ---------- */

  P.renderSizes = function () {
    var grid = $(this.root, '[data-pd-size-grid]');
    if (!grid || this.sizeIdx < 0) return;
    var self = this;
    var old = this.sizeQty || {};
    this.sizeQty = {};
    this.sizeMax = {};
    this.sizeGrid = grid;
    grid.innerHTML = '';
    // Am PC Platz sparen: nur S, M, L, XL direkt zeigen, der Rest im Größen-Fenster
    var MAIN = ['S', 'M', 'L', 'XL'];
    var allVals = this.optionValues(this.sizeIdx);
    var useMore = allVals.length > 5 && allVals.some(function (v) { return MAIN.indexOf(String(v).toUpperCase()) !== -1; });
    this.ensureSizeStyles();
    allVals.forEach(function (val) {
      var v = self.findVariant(val);
      var ok = v && v.available && v.options[self.sizeIdx] === val;
      // Echter Bestand (nur wenn Shopify ihn zählt und Überverkauf aus ist)
      var max = ok && typeof v.stock === 'number' ? v.stock : null;
      if (max === 0) ok = false;
      var cell = document.createElement('div');
      cell.className = 'pd__size-cell' + (ok ? '' : ' is-soldout');
      cell.innerHTML = '<span class="pd__size-name"></span>' +
        '<div class="pd__size-step">' +
        '<button type="button" data-d="-1" aria-label="weniger">&minus;</button>' +
        '<input type="number" min="0" step="1" inputmode="numeric" value="0">' +
        '<button type="button" data-d="1" aria-label="mehr">+</button></div>';
      cell.firstChild.textContent = val;
      var input = cell.querySelector('input');
      input.setAttribute('aria-label', 'Menge ' + val);
      if (!ok) {
        input.disabled = true;
        cell.querySelectorAll('button').forEach(function (bt) { bt.disabled = true; });
        var so = document.createElement('small');
        so.textContent = 'ausverkauft';
        cell.appendChild(so);
      } else {
        if (max !== null) {
          self.sizeMax[val] = max;
          input.max = max;
          var left = document.createElement('small');
          left.className = 'pd__size-left';
          left.style.cssText = 'margin-top:4px;font-size:11px;line-height:1.2;color:#d0302f;display:' + (max < 200 ? 'block' : 'none') + ';';
          left.textContent = 'noch ' + max + ' verfügbar';
          cell.appendChild(left);
        }
        self.sizeQty[val] = Math.min(old[val] || 0, max !== null ? max : 9999);
        input.value = self.sizeQty[val];
        input.addEventListener('input', function () { self.setSizeQty(val, input.value, true); });
        input.addEventListener('blur', function () { input.value = self.sizeQty[val]; });
        input.addEventListener('focus', function () { input.select(); });
        cell.querySelectorAll('button').forEach(function (bt) {
          bt.addEventListener('click', function () {
            self.setSizeQty(val, (self.sizeQty[val] || 0) + parseInt(bt.dataset.d, 10));
          });
        });
      }
      cell.dataset.value = val;
      if (useMore && MAIN.indexOf(String(val).toUpperCase()) === -1) cell.classList.add('is-more');
      grid.appendChild(cell);
    });
    var holder = $(this.root, '[data-pd-more-sizes]');
    if (holder) holder.remove();
    if (useMore) {
      holder = document.createElement('div');
      holder.setAttribute('data-pd-more-sizes', '');
      holder.className = 'pd__more-sizes-wrap';
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'pd__more-colors';
      more.addEventListener('click', function () { self.openSizeModal(); });
      holder.appendChild(more);
      grid.parentNode.insertBefore(holder, grid.nextSibling);
    }
    this.syncQty();
  };

  P.ensureSizeStyles = function () {
    if (document.getElementById('pd-size-more-css')) return;
    var st = document.createElement('style');
    st.id = 'pd-size-more-css';
    st.textContent = '.pd__size-grid:not(.is-all) .pd__size-cell.is-more{display:none}'
      + '.pd__more-sizes-wrap{margin-top:10px}'
      + '.pd__sm-foot{display:flex;flex-wrap:wrap;gap:12px;align-items:center;justify-content:space-between;padding:14px 20px;border-top:1px solid #e6e6e6;background:#fff}'
      + '.pd__sm-sum{font-size:14px;line-height:1.35}.pd__sm-sum strong{font-size:18px;display:block}'
      + '.pd__sm-actions{display:flex;gap:8px;flex-wrap:wrap}'
      + '.pd__sm-btn{border:1px solid #111;background:#fff;color:#111;border-radius:6px;padding:12px 16px;font-weight:600;cursor:pointer;font-size:14px}'
      + '.pd__sm-btn--dark{background:#111;color:#fff}'
      + '.pd__cm-body .pd__size-grid{margin:0}';
    document.head.appendChild(st);
  };

  // Text am Knopf "Weitere Größen" aktuell halten
  P.updateMoreSizes = function () {
    var holder = $(this.root, '[data-pd-more-sizes]') || (this.sizeModal && this.sizeModal.querySelector('[data-pd-more-sizes]'));
    var btn = holder && holder.querySelector('button');
    if (!btn) return;
    var self = this, n = 0, cnt = 0;
    $$(document, '.pd__size-cell.is-more').forEach(function (c) {
      cnt++;
      n += (self.sizeQty || {})[c.dataset.value] || 0;
    });
    btn.innerHTML = '<span class="pd__more-dots" aria-hidden="true"></span><span>Alle Größen anzeigen</span><span class="pd__more-count">' + (n ? n + ' Stück gewählt' : '+' + cnt) + '</span>';
  };

  P.openSizeModal = function () {
    var self = this;
    var grid = $(this.root, '[data-pd-size-grid]');
    if (!grid) return;
    var home = grid.parentNode, next = grid.nextSibling;
    var m = document.createElement('div');
    m.className = 'pd__cm';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Alle Größen');
    m.innerHTML = '<div class="pd__cm-back" data-cm-close></div><div class="pd__cm-box">'
      + '<div class="pd__cm-head"><p class="pd__cm-title">Alle Größen</p><span class="pd__cm-sub">' + (this.selColor || '') + '</span>'
      + '<button type="button" class="pd__cm-x" data-cm-close aria-label="Schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>'
      + '<div class="pd__cm-body" data-sm-body></div>'
      + '<div class="pd__sm-foot"><div class="pd__sm-sum"><span data-sm-qty></span><strong data-sm-price></strong></div>'
      + '<div class="pd__sm-actions"><button type="button" class="pd__sm-btn" data-cm-close>Fertig</button>'
      + '<button type="button" class="pd__sm-btn pd__sm-btn--dark" data-sm-add>In den Warenkorb legen</button></div></div></div>';
    m.querySelector('[data-sm-body]').appendChild(grid);
    grid.classList.add('is-all');
    var priceEl = $(this.root, '[data-pd-price]');
    function sync() {
      var q = self.totalQty();
      m.querySelector('[data-sm-qty]').textContent = 'Gesamt: ' + q + ' Stück';
      m.querySelector('[data-sm-price]').textContent = priceEl ? priceEl.textContent : '';
    }
    var obs = priceEl && window.MutationObserver ? new MutationObserver(sync) : null;
    if (obs) obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    var tick = setInterval(sync, 400);
    self.sizeModalSync = sync;
    sync();
    var last = document.activeElement;
    function key(e) { if (e.key === 'Escape') close(); }
    function close() {
      document.removeEventListener('keydown', key);
      document.documentElement.classList.remove('pd-cm-open');
      if (obs) obs.disconnect();
      clearInterval(tick);
      self.sizeModalSync = null;
      grid.classList.remove('is-all');
      home.insertBefore(grid, next && next.parentNode === home ? next : null);
      m.remove();
      self.sizeModal = null;
      self.updateMoreSizes();
      if (last && last.focus) last.focus();
    }
    m.querySelectorAll('[data-cm-close]').forEach(function (el) { el.addEventListener('click', close); });
    m.querySelector('[data-sm-add]').addEventListener('click', function () {
      close();
      if (self.form && self.form.requestSubmit) self.form.requestSubmit();
      else { var b = $(self.root, '[data-pd-add]'); if (b) b.click(); }
    });
    document.addEventListener('keydown', key);
    document.body.appendChild(m);
    document.documentElement.classList.add('pd-cm-open');
    this.sizeModal = m;
    var first = grid.querySelector('input:not([disabled])');
    if (first) first.focus();
  };

  P.setSizeQty = function (val, qty, typing) {
    qty = parseInt(qty, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    if (qty > 9999) qty = 9999;
    var max = this.sizeMax && typeof this.sizeMax[val] === 'number' ? this.sizeMax[val] : null;
    var capped = max !== null && qty > max;
    if (capped) qty = max;
    this.sizeQty[val] = qty;
    this.formError('');
    var sel = '.pd__size-cell[data-value="' + String(val).replace(/"/g, '\\"') + '"]';
    var gridEl = this.sizeGrid || this.root;
    var note = $(gridEl, sel + ' .pd__size-left');
    if (note) {
      note.style.fontWeight = capped ? '700' : '';
      if (capped) note.style.display = 'block';
    }
    if (!typing || capped) {
      var cell = $(gridEl, '.pd__size-cell[data-value="' + String(val).replace(/"/g, '\\"') + '"] input');
      if (cell) cell.value = qty;
    }
    this.syncQty();
  };

  P.totalQty = function () {
    var q = this.sizeQty || {}, t = 0;
    Object.keys(q).forEach(function (k) { t += q[k] || 0; });
    return t;
  };

  // Gesamtmenge an die Staffelpreis-Tabelle geben, damit Stückpreis und Summe stimmen
  P.syncQty = function () {
    var total = this.totalQty();
    this.updateMoreSizes();
    if (this.sizeModalSync) this.sizeModalSync();
    var out = $(this.root, '[data-pd-size-total] strong');
    if (out) out.textContent = total;
    if (total > 0) {
      var err = $(this.root, '[data-pd-size-error]');
      if (err) err.hidden = true;
      var grid = $(this.root, '[data-pd-size-grid]');
      if (grid) grid.classList.remove('is-error');
    }
    var q = $(this.root, '.qbp__input');
    if (q) {
      q.value = Math.max(total, 1);
      q.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      this.qbpTotal = null;
      this.renderTotal();
    }
  };

  P.sizeLines = function () {
    var self = this, lines = [];
    if (this.sizeIdx < 0) {
      // Ohne Größen kommt die Menge aus dem Mengenfeld der Staffel (oder dem einfachen Mengenfeld)
      var q = this.form ? parseInt(new FormData(this.form).get('quantity'), 10) : 0;
      return [{ variant: this.currentVariant(), qty: q > 0 ? q : 1 }];
    }
    this.optionValues(this.sizeIdx).forEach(function (val) {
      var qty = (self.sizeQty || {})[val] || 0;
      if (qty > 0) lines.push({ variant: self.findVariant(val), qty: qty, size: val });
    });
    return lines;
  };

  /* ---------- Rechte an Motiven ---------- */

  P.hasUploads = function () {
    var self = this, found = false;
    function check(list) {
      (list || []).forEach(function (o) { if (o.pdKind === 'image' || o.pdKind === 'svg') found = true; });
    }
    this.views.forEach(function (v) { if (v !== self.view()) check(self.designs[v.name]); });
    if (this.canvas) check(this.canvas.getObjects());
    return found;
  };

  P.updateRights = function () {
    var need = this.hasUploads();
    var buyFc = $(this.root, '[data-pd-fc-buy]');
    if (buyFc) buyFc.hidden = !need;
    this.renderTotal();
    var box = $(this.root, '[data-pd-rights]');
    if (!box) return;
    box.hidden = !need;
    if (!need) { var e = $(this.root, '[data-pd-rights-error]'); if (e) e.hidden = true; }
  };

  /* Datei-Check oder Logo-Überarbeitung: einmal je Design, nur wenn ein eigenes Bild drauf ist */
  P.serviceActive = function () { return this.hasUploads() ? this.service : ''; };

  P.serviceCents = function () {
    var s = this.serviceActive();
    return s === 'check' ? this.fileCheckCents : s === 'rework' ? this.reworkCents : 0;
  };

  P.setService = function (s) {
    this.service = s === 'check' || s === 'rework' ? s : '';
    var cur = this.service;
    $$(this.root, '[data-pd-fc-input]').forEach(function (i) { i.checked = cur === 'check'; });
    $$(this.root, '[data-pd-rw-input]').forEach(function (i) { i.checked = cur === 'rework'; });
    this.renderTotal();
  };

  /* ---------- Ansichten und Produktbild ---------- */

  P.imageFor = function (view, color, strict) {
    var media = this.data.media || [];
    var c = lc(color);
    var hits = media.filter(function (m) { return lc(m.alt).indexOf(view.match) !== -1; });
    if (c) {
      var withColor = hits.filter(function (m) { return lc(m.alt).indexOf(c) !== -1; });
      if (withColor.length) return withColor[0];
    }
    var multi = this.colorIdx >= 0 && this.optionValues(this.colorIdx).length > 1;
    // Im Admin gewähltes Bild der Druckseite: bei Produkten ohne Farbauswahl immer, sonst nach den Farbbildern
    if (view.img && !multi) return view.img;
    if (hits.length && !(strict && c && this.optionValues(this.colorIdx).length > 1)) return hits[0];
    if (view === this.views[0]) {
      var self = this;
      var v = this.data.variants.filter(function (x) {
        return self.colorIdx < 0 || x.options[self.colorIdx] === color;
      }).filter(function (x) { return x.image; })[0];
      if (v) return { src: v.image, thumb: v.thumb, ratio: null };
      if (view.img) return view.img;
      if (hits.length) return hits[0];
      if (media[0]) return media[0];
    }
    return view.img || hits[0] || null;
  };

  P.availableViews = function () {
    var self = this;
    return this.views.filter(function (v) { return !!self.imageFor(v, self.selColor); });
  };

  P.renderViews = function () {
    var wrap = $(this.root, '[data-pd-views]');
    var self = this;
    var views = this.availableViews();
    wrap.innerHTML = '';
    if (views.length < 2) return;
    views.forEach(function (view) {
      var idx = self.views.indexOf(view);
      var img = self.imageFor(view, self.selColor);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pd__view' + (idx === self.viewIndex ? ' is-active' : '');
      b.dataset.index = idx;
      b.innerHTML = '<span class="pd__view-img"><img alt=""></span><span class="pd__view-label"></span>';
      b.querySelector('img').src = img.thumb || img.src;
      b.querySelector('.pd__view-label').textContent = view.name;
      if (view.readonly) b.classList.add('is-readonly');
      if (self.hasDesign(view.name)) {
        var dot = document.createElement('span');
        dot.className = 'pd__view-dot';
        b.firstChild.appendChild(dot);
      }
      b.addEventListener('click', function () { self.showView(idx); });
      wrap.appendChild(b);
    });
  };

  P.hasDesign = function (name) {
    if (name === this.views[this.viewIndex].name && this.canvas && !this.loading) {
      return this.canvas.getObjects().length > 0;
    }
    var d = this.designs[name];
    return !!(d && d.length);
  };

  P.view = function () { return this.views[this.viewIndex]; };

  P.ratioFor = function (view) {
    var img = this.imageFor(view, this.selColor);
    if (view === this.view() && this.imgRatio) return this.imgRatio;
    return (img && img.ratio) ? img.ratio : 1;
  };

  // Druckbereich in internen Einheiten
  P.printArea = function (view) {
    view = view || this.view();
    var logicalH = LOGICAL_W / this.ratioFor(view);
    var w = view.w / 100 * LOGICAL_W;
    return {
      x: view.x / 100 * LOGICAL_W,
      y: view.y / 100 * logicalH,
      w: w,
      h: w * view.cm_h / view.cm_w
    };
  };

  P.setMockupImage = function () {
    var img = $(this.root, '[data-pd-mockup-img]');
    var m = this.imageFor(this.view(), this.selColor);
    var self = this;
    if (!m) return;
    if (img.getAttribute('src') !== m.src) {
      img.onload = function () {
        if (img.naturalWidth) self.imgRatio = img.naturalWidth / img.naturalHeight;
        self.layout();
      };
      img.src = m.src;
    }
    if (m.ratio) this.imgRatio = m.ratio;
    this.layout();
  };

  P.showView = function (idx, first) {
    if (!first) this.saveView();
    this.viewIndex = idx;
    this.imgRatio = null;
    this.setMockupImage();
    this.loadView();
    this.renderViews();
  };

  P.saveView = function () {
    if (!this.canvas || this.loading) return;
    this.designs[this.view().name] = serialize(this.canvas);
  };

  P.loadView = function () {
    var self = this;
    var objs = this.designs[this.view().name] || [];
    this.loading = true;
    this.canvas.discardActiveObject();
    this.canvas.clear();
    this.canvas.loadFromJSON({ objects: objs }, function () {
      fixCurves(self.canvas.getObjects());
      self.loading = false;
      self.canvas.getObjects().forEach(function (o) { self.styleObject(o); });
      self.canvas.getObjects().forEach(function (o) { self.constrain(o); o.__pdOut = false; });
      self.checkOverlap();
      self.updateMotifs();
      self.canvas.requestRenderAll();
      if (!self.history[self.view().name]) self.history[self.view().name] = { stack: [JSON.stringify(objs)], idx: 0 };
      self.updateHistoryButtons();
      self.refreshFonts();
      self.updateRights();
      self.checkDpi();
    });
  };

  /* ---------- Leinwand ---------- */

  // Griffe wie bei Spreadshirt: oben links löschen, oben rechts drehen, unten skalieren
  function controlIcon(kind) {
    return function (ctx, left, top) {
      ctx.save();
      ctx.translate(left, top);
      ctx.beginPath();
      ctx.arc(0, 0, 11, 0, Math.PI * 2);
      ctx.shadowColor = 'rgba(0,0,0,.25)';
      ctx.shadowBlur = 4;
      ctx.fillStyle = '#fff';
      ctx.fill();
      ctx.shadowBlur = 0;
      ctx.lineWidth = 1;
      ctx.strokeStyle = BLUE;
      ctx.stroke();
      ctx.lineWidth = 1.7;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.strokeStyle = kind === 'del' ? '#e53935' : '#111';
      ctx.beginPath();
      if (kind === 'del') {
        ctx.moveTo(-4, -4); ctx.lineTo(4, 4); ctx.moveTo(4, -4); ctx.lineTo(-4, 4);
      } else if (kind === 'rot') {
        ctx.arc(0, 0, 5, -Math.PI * 0.35, Math.PI * 1.25);
        ctx.moveTo(4.6, -5.6); ctx.lineTo(3.2, -2.4); ctx.lineTo(6.6, -1.9);
      } else {
        ctx.moveTo(-4, 4); ctx.lineTo(4, -4);
        ctx.moveTo(0, -4); ctx.lineTo(4, -4); ctx.lineTo(4, 0);
        ctx.moveTo(-4, 0); ctx.lineTo(-4, 4); ctx.lineTo(0, 4);
      }
      ctx.stroke();
      ctx.restore();
    };
  }

  P.setupControls = function () {
    var self = this;
    var cu = fabric.controlsUtils;
    var size = 26;
    var controls = {
      tl: new fabric.Control({
        x: -0.5, y: -0.5, cursorStyle: 'pointer', sizeX: size, sizeY: size, touchSizeX: 36, touchSizeY: 36,
        mouseUpHandler: function (e, tr) { self.removeObject(tr.target); return true; },
        render: controlIcon('del')
      }),
      tr: new fabric.Control({
        x: 0.5, y: -0.5, sizeX: size, sizeY: size, touchSizeX: 36, touchSizeY: 36, actionName: 'rotate',
        actionHandler: cu.rotationWithSnapping, cursorStyleHandler: cu.rotationStyleHandler,
        render: controlIcon('rot')
      }),
      br: new fabric.Control({
        x: 0.5, y: 0.5, sizeX: size, sizeY: size, touchSizeX: 36, touchSizeY: 36, actionName: 'scale',
        actionHandler: cu.scalingEqually, cursorStyleHandler: cu.scaleCursorStyleHandler,
        render: controlIcon('scale')
      }),
      bl: new fabric.Control({
        x: -0.5, y: 0.5, sizeX: size, sizeY: size, touchSizeX: 36, touchSizeY: 36, actionName: 'scale',
        actionHandler: cu.scalingEqually, cursorStyleHandler: cu.scaleCursorStyleHandler,
        render: controlIcon('scale')
      })
    };
    fabric.Object.prototype.controls = controls;
    if (fabric.IText) fabric.IText.prototype.controls = controls;
    fabric.Object.prototype.set({
      transparentCorners: false,
      borderColor: BLUE,
      borderScaleFactor: 1.5,
      padding: 6,
      snapAngle: 45,
      snapThreshold: 5,
      // ohne Zwischenbild, damit Bilder und Texte auch groß gezogen scharf bleiben
      objectCaching: false
    });
  };

  P.setupCanvas = function () {
    var self = this;
    var el = $(this.root, '[data-pd-canvas]');
    this.setupControls();

    this.canvas = new fabric.Canvas(el, {
      preserveObjectStacking: true,
      selection: true,
      selectionColor: 'rgba(47,111,237,0.08)',
      selectionBorderColor: BLUE,
      selectionLineWidth: 1,
      enableRetinaScaling: true,
      stopContextMenu: true
    });

    var c = this.canvas;
    // Bei gedrehter Ansicht die Mausposition zurückdrehen. fabric selbst
    // kennt nur Verschiebung und Skalierung des Elements.
    var basePointer = c.getPointer;
    c.getPointer = function (e, ignoreVpt) {
      if (!self.viewRot) return basePointer.call(this, e, ignoreVpt);
      if (this._absolutePointer && !ignoreVpt) return this._absolutePointer;
      if (this._pointer && ignoreVpt) return this._pointer;
      var t = (e.changedTouches && e.changedTouches[0]) || (e.touches && e.touches[0]) || e;
      var r = this.upperCanvasEl.getBoundingClientRect();
      var odd = self.viewRot % 180 !== 0;
      var k = (odd ? r.width / this.height : r.width / this.width) || 1;
      var dx = (t.clientX - (r.left + r.width / 2)) / k, dy = (t.clientY - (r.top + r.height / 2)) / k;
      var a = -self.viewRot * Math.PI / 180, cos = Math.round(Math.cos(a)), sin = Math.round(Math.sin(a));
      var p = new fabric.Point(dx * cos - dy * sin + this.width / 2, dx * sin + dy * cos + this.height / 2);
      return ignoreVpt ? p : this.restorePointerVpt(p);
    };
    function changed(e) {
      if (self.loading || self.batch) return;
      if (e && e.target && e.target.canvas) self.constrain(e.target);
      self.checkOverlap();
      self.pushHistory(); self.persist(); self.renderViews(); self.syncToolbar(); self.updateRights(); self.checkDpi(); self.updateMotifs();
    }
    this.changed = changed;
    c.on('object:added', changed);
    c.on('object:removed', changed);
    c.on('object:modified', changed);
    c.on('text:changed', function (e) {
      if (e.target.pdCurve) applyCurve(e.target);
      self.constrain(e.target);
      self.syncTextInput(e.target);
    });
    c.on('text:editing:exited', changed);
    // Startlage merken: Vorlagenzeilen bewegen sich gemeinsam, Größe und Drehung haben eine harte Grenze
    c.on('mouse:down', function (e) { if (e.target) self.rememberStart(e.target); });
    c.on('object:moving', function (e) { self.onMoving(e.target); });
    c.on('object:scaling', function (e) { self.limitTransform(e.target); self.syncSizeRange(); self.checkDpi(); });
    c.on('object:rotating', function (e) { self.limitTransform(e.target); });
    c.on('mouse:up', function () { self.showGuides(false, false); });
    c.on('selection:created', function () { self.expandSelection(); self.onSelect(); });
    c.on('selection:updated', function () { self.expandSelection(); self.onSelect(); });
    c.on('selection:cleared', function () { self.onSelect(); });
    c.on('after:render', function () { self.updateDims(); self.drawOverlap(); });

    // Schriften, die später ankommen, neu vermessen
    if (document.fonts && document.fonts.addEventListener) {
      document.fonts.addEventListener('loadingdone', function () {
        clearTimeout(self.fontTimer);
        self.fontTimer = setTimeout(function () { if (!self.loading) self.refreshFonts(); }, 50);
      });
    }

    if (window.ResizeObserver) {
      new ResizeObserver(function () { self.layout(); }).observe($(this.root, '[data-pd-viewport]'));
    } else {
      window.addEventListener('resize', function () { self.layout(); });
    }
  };

  P.layout = function () {
    var vp = $(this.root, '[data-pd-viewport]');
    var mock = $(this.root, '[data-pd-mockup]');
    if (!vp || !this.canvas) return;
    var cs = getComputedStyle(vp);
    var availW = vp.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var availH = vp.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var mobile = window.matchMedia('(max-width: 899px)').matches;
    if (mobile) availH = availW * 1.15;
    else availH = Math.min(availH, window.innerHeight - 200);
    var ratio = this.imgRatio || this.ratioFor(this.view());
    var odd = this.viewRot % 180 !== 0;
    // Quer gedreht: Höhe des Produkts füllt die Breite der Bühne und umgekehrt
    var w = odd ? Math.min(availW * ratio, availH, 900 * ratio) : Math.min(availW, availH * ratio, 900);
    if (w <= 0) return;
    w = Math.floor(w * this.zoom);
    var h = Math.round(w / ratio);
    mock.style.width = w + 'px';
    mock.style.height = h + 'px';
    mock.style.transform = this.viewRot ? 'rotate(' + this.viewRot + 'deg)' : '';
    // Platz im Layout an die gedrehte Größe anpassen
    mock.style.margin = odd ? ((w - h) / 2) + 'px ' + ((h - w) / 2) + 'px' : '';
    mock.dataset.pdViewRot = this.viewRot;
    vp.classList.toggle('is-zoomed', this.zoom > 1);
    this.canvas.setDimensions({ width: w, height: h });
    this.canvas.setZoom(w / LOGICAL_W);
    var pa = this.printArea();
    // Alles außerhalb des Druckbereichs wird ausgeblendet
    this.canvas.clipPath = new fabric.Rect({ left: pa.x, top: pa.y, width: pa.w, height: pa.h, absolutePositioned: true });
    var s = w / LOGICAL_W;
    var area = $(this.root, '[data-pd-printarea]');
    area.style.left = pa.x * s + 'px';
    area.style.top = pa.y * s + 'px';
    area.style.width = pa.w * s + 'px';
    area.style.height = pa.h * s + 'px';
    var gv = $(this.root, '[data-pd-guide-v]'), gh = $(this.root, '[data-pd-guide-h]');
    if (gv) { gv.style.left = (pa.x + pa.w / 2) * s + 'px'; gv.style.top = pa.y * s + 'px'; gv.style.height = pa.h * s + 'px'; }
    if (gh) { gh.style.top = (pa.y + pa.h / 2) * s + 'px'; gh.style.left = pa.x * s + 'px'; gh.style.width = pa.w * s + 'px'; }
    var label = $(this.root, '[data-pd-printarea-label]');
    if (label) label.textContent = 'Druckbereich ' + round1(this.view().cm_w) + ' × ' + round1(this.view().cm_h) + ' cm';
    this.canvas.calcOffset();
    this.canvas.requestRenderAll();
    if (this.zoom > 1) {
      vp.scrollLeft = (vp.scrollWidth - vp.clientWidth) / 2;
      vp.scrollTop = this.viewRot ? (vp.scrollHeight - vp.clientHeight) / 2 : Math.max(0, pa.y * s - 40);
    }
  };

  /* ---------- Ansicht drehen ---------- */

  // Dreht nur die Ansicht. Druckdaten bleiben in Produktlage.
  P.rotateView = function (deg) {
    this.viewRot = (((this.viewRot + deg) % 360) + 360) % 360;
    this.showGuides(false, false);
    this.layout();
    this.updateRotateUi();
  };

  P.updateRotateUi = function () {
    var out = $(this.root, '[data-pd-rot-value]');
    if (out) out.textContent = this.viewRot + '°';
    var reset = $(this.root, '[data-pd-rot-reset]');
    if (reset) reset.disabled = !this.viewRot;
  };

  // Druckbereich so, wie ihn der Kunde gerade sieht (bei 90° Breite und Höhe getauscht)
  P.screenArea = function () {
    var pa = this.printArea();
    var odd = this.viewRot % 180 !== 0;
    return { w: odd ? pa.h : pa.w, h: odd ? pa.w : pa.h, cx: pa.x + pa.w / 2, cy: pa.y + pa.h / 2 };
  };

  // Neue Objekte stehen auf dem Bildschirm gerade, also gegen die Ansicht gedreht.
  // Mehrere Objekte (Vorlage) drehen gemeinsam um die Mitte des Druckbereichs.
  P.turnUpright = function (list) {
    var a = this.viewRot;
    if (!a) return;
    if (!Array.isArray(list)) list = [list];
    var sa = this.screenArea();
    var pivot = new fabric.Point(sa.cx, sa.cy);
    var rad = fabric.util.degreesToRadians(-a);
    list.forEach(function (o) {
      var c = fabric.util.rotatePoint(o.getCenterPoint(), pivot, rad);
      o.set('angle', (((o.angle || 0) - a) % 360 + 360) % 360);
      o.setPositionByOrigin(c, 'center', 'center');
      o.setCoords();
    });
  };

  P.showArea = function (on) {
    var area = $(this.root, '[data-pd-printarea]');
    if (area) area.classList.toggle('is-visible', !!on);
  };

  P.showGuides = function (v, h) {
    var gv = $(this.root, '[data-pd-guide-v]'), gh = $(this.root, '[data-pd-guide-h]');
    if (gv) gv.hidden = !v;
    if (gh) gh.hidden = !h;
  };

  P.styleObject = function (o) {
    o.set({ lockScalingFlip: true, borderColor: BLUE });
  };

  P.isOut = function (o) {
    var pa = this.printArea();
    var tol = 0.5;
    var r = o.getBoundingRect(true, true);
    return r.left < pa.x - tol || r.top < pa.y - tol ||
      r.left + r.width > pa.x + pa.w + tol || r.top + r.height > pa.y + pa.h + tol;
  };

  /* ---------- Harte Grenze, Vorlagen, Überlappung ---------- */

  // Das Objekt selbst oder alle Zeilen seiner Vorlage
  P.members = function (o) {
    if (!o) return [];
    if (!o.pdGroup || o.type === 'activeSelection' || o.group) return [o];
    return this.canvas.getObjects().filter(function (x) { return x.pdGroup === o.pdGroup; });
  };

  P.unionRect = function (list) {
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    list.forEach(function (o) {
      var r = o.getBoundingRect(true, true);
      minX = Math.min(minX, r.left); minY = Math.min(minY, r.top);
      maxX = Math.max(maxX, r.left + r.width); maxY = Math.max(maxY, r.top + r.height);
    });
    return { left: minX, top: minY, width: maxX - minX, height: maxY - minY };
  };

  P.shiftList = function (list, dx, dy) {
    if (!dx && !dy) return;
    list.forEach(function (o) { o.set({ left: o.left + dx, top: o.top + dy }); o.setCoords(); });
  };

  // Verschiebt die Objekte so, dass sie ganz im Druckbereich liegen
  P.keepInside = function (list) {
    var pa = this.printArea();
    var r = this.unionRect(list);
    function fix(start, size, min, max) {
      if (size > max - min) return (min + max) / 2 - (start + size / 2);
      if (start < min) return min - start;
      if (start + size > max) return max - (start + size);
      return 0;
    }
    this.shiftList(list, fix(r.left, r.width, pa.x, pa.x + pa.w), fix(r.top, r.height, pa.y, pa.y + pa.h));
  };

  // Zu groß wird verkleinert, über den Rand wird zurückgeschoben
  P.constrain = function (o) {
    if (!o || !o.getBoundingRect) return;
    var pa = this.printArea();
    var list = this.members(o);
    function shrink(x, f, origin) {
      var c = x.getCenterPoint();
      if (origin) c = new fabric.Point(origin.x + (c.x - origin.x) * f, origin.y + (c.y - origin.y) * f);
      x.set({ scaleX: x.scaleX * f, scaleY: x.scaleY * f });
      x.setPositionByOrigin(c, 'center', 'center');
      x.setCoords();
    }
    list.forEach(function (x) {
      var r = x.getBoundingRect(true, true);
      var f = Math.min(1, pa.w / r.width, pa.h / r.height) * 0.999;
      if (f < 0.998) shrink(x, f);
    });
    var u = this.unionRect(list);
    var g = Math.min(1, pa.w / u.width, pa.h / u.height) * 0.999;
    if (g < 0.998) {
      var mid = new fabric.Point(u.left + u.width / 2, u.top + u.height / 2);
      list.forEach(function (x) { shrink(x, g, mid); });
    }
    this.keepInside(list);
  };

  P.rememberStart = function (o) {
    if (this.isOut(o)) { this.constrain(o); this.canvas.requestRenderAll(); }
    o.__pdOk = { left: o.left, top: o.top, scaleX: o.scaleX, scaleY: o.scaleY, angle: o.angle };
    this.members(o).forEach(function (x) { x.__pdStart = { left: x.left, top: x.top }; });
  };

  // Größer ziehen oder drehen hört am Rand des Druckbereichs auf
  P.limitTransform = function (o) {
    if (!o) return;
    if (this.isOut(o)) {
      if (o.__pdOk) { o.set(o.__pdOk); o.setCoords(); }
      else this.constrain(o);
      this.flashEdge();
    } else {
      o.__pdOk = { left: o.left, top: o.top, scaleX: o.scaleX, scaleY: o.scaleY, angle: o.angle };
    }
  };

  P.onMoving = function (o) {
    var list = this.members(o);
    if (list.length > 1 && o.__pdStart) {
      var dx = o.left - o.__pdStart.left, dy = o.top - o.__pdStart.top;
      list.forEach(function (x) {
        if (x === o || !x.__pdStart) return;
        x.set({ left: x.__pdStart.left + dx, top: x.__pdStart.top + dy });
        x.setCoords();
      });
    }
    this.snap(list);
    var before = this.unionRect(list);
    this.keepInside(list);
    var after = this.unionRect(list);
    if (Math.abs(before.left - after.left) > 0.5 || Math.abs(before.top - after.top) > 0.5) this.flashEdge();
    this.checkOverlap(true);
  };

  // Rahmen kurz rot zeigen, wenn man an die Grenze stößt
  P.flashEdge = function () {
    var area = $(this.root, '[data-pd-printarea]');
    if (!area) return;
    area.classList.add('is-edge');
    clearTimeout(this.edgeTimer);
    this.edgeTimer = setTimeout(function () { area.classList.remove('is-edge'); }, 600);
  };

  // Mehrfachauswahl nimmt immer die ganze Vorlage mit
  P.expandSelection = function () {
    var c = this.canvas;
    var a = c.getActiveObject();
    if (this.expanding || !a || a.type !== 'activeSelection') return;
    var self = this;
    var objs = a.getObjects(), all = objs.slice();
    objs.forEach(function (o) {
      if (!o.pdGroup) return;
      c.getObjects().forEach(function (x) { if (x.pdGroup === o.pdGroup && all.indexOf(x) === -1) all.push(x); });
    });
    if (all.length === objs.length) return;
    this.expanding = true;
    c.discardActiveObject();
    c.setActiveObject(new fabric.ActiveSelection(all, { canvas: c }));
    this.expanding = false;
    c.requestRenderAll();
  };

  P.selectGroup = function (o) {
    var list = this.members(o);
    if (list.length < 2) return;
    this.canvas.discardActiveObject();
    this.canvas.setActiveObject(new fabric.ActiveSelection(list, { canvas: this.canvas }));
    this.canvas.requestRenderAll();
    this.onSelect();
  };

  P.checkOverlap = function (quiet) {
    var bad = overlapping(this.canvas.getObjects());
    this.badObjects = bad;
    var has = bad.length > 0;
    this.overlapViews[this.view().name] = has;
    var box = $(this.root, '[data-pd-overlap]');
    if (box) box.hidden = !has;
    var stage = $(this.root, '[data-pd-stage]');
    if (stage) stage.classList.toggle('has-overlap', has);
    if (!quiet) this.updateBlocked();
    return has;
  };

  P.drawOverlap = function () {
    var bad = this.badObjects;
    if (!bad || !bad.length) return;
    var ctx = this.canvas.getContext();
    ctx.save();
    ctx.strokeStyle = RED;
    ctx.lineWidth = 2;
    ctx.setLineDash([6, 4]);
    bad.forEach(function (o) {
      if (!o.canvas) return;
      var r = o.getBoundingRect();
      ctx.strokeRect(r.left - 3, r.top - 3, r.width + 6, r.height + 6);
    });
    ctx.restore();
  };

  // Überlappung in einer anderen Ansicht, ohne sie zu öffnen
  P.viewHasOverlap = function (view) {
    if (view === this.view()) return Promise.resolve(this.checkOverlap(true));
    var sc = new fabric.StaticCanvas(null, { width: 10, height: 10 });
    return loadInto(sc, this.designs[view.name] || []).then(function () {
      var has = overlapping(sc.getObjects()).length > 0;
      sc.dispose();
      return has;
    });
  };

  P.updateBlocked = function () {
    var self = this;
    var any = this.views.some(function (v) { return self.overlapViews[v.name]; });
    var btn = $(this.root, '[data-pd-add]');
    if (btn) btn.classList.toggle('is-blocked', any);
    var err = $(this.root, '[data-pd-overlap-error]');
    if (err) err.hidden = !any;
  };

  /* ---------- Motive zählen und Aufpreis ---------- */

  P.motifCount = function () {
    var self = this, n = 0;
    this.views.forEach(function (v) {
      n += v === self.view() && !self.loading ? countUnits(self.canvas.getObjects()) : countUnits(self.designs[v.name]);
    });
    return n;
  };

  P.extraMotifs = function () { return Math.max(0, this.motifCount() - 1); };

  P.updateMotifs = function () {
    var box = $(this.root, '[data-pd-motifs]');
    var n = this.motifCount();
    var extra = Math.max(0, n - 1);
    if (box) {
      if (!n) box.textContent = 'Ein Druckmotiv ist im Preis enthalten.';
      else if (!extra) box.textContent = '1 Motiv, im Preis enthalten.';
      else box.textContent = n + ' Motive: 1 im Preis enthalten, ' + (extra === 1 ? '1 weiteres' : extra + ' weitere') + ' je ' + this.formatMoney(this.extraMotifCents) + ' pro Stück.';
      box.classList.toggle('has-extra', extra > 0);
    }
    this.renderTotal();
  };

  // Summe = Staffelpreis-Summe + Aufpreis für weitere Motive
  P.renderTotal = function () {
    var price = $(this.root, '[data-pd-price]');
    if (!price) return;
    var qty = Math.max(this.totalQty(), 1);
    var base = this.qbpTotal;
    if (base == null) {
      var v = this.currentVariant();
      base = v ? v.price * qty : 0;
    }
    price.textContent = this.formatMoney(base + this.extraMotifs() * this.extraMotifCents * qty + this.serviceCents());
  };

  // Maße des ausgewählten Objekts in cm, wie bei Spreadshirt
  P.updateDims = function () {
    var dw = $(this.root, '[data-pd-dim-w]'), dh = $(this.root, '[data-pd-dim-h]');
    if (!dw || !dh) return;
    var o = this.canvas.getActiveObject();
    if (!o || this.loading) { dw.hidden = true; dh.hidden = true; return; }
    var r = o.getBoundingRect();
    var rr = o.getBoundingRect(true, true);
    var cmPer = this.view().cm_w / this.printArea().w;
    dw.textContent = round1(rr.width * cmPer) + ' cm';
    dh.textContent = round1(rr.height * cmPer) + ' cm';
    dw.style.left = (r.left + r.width / 2) + 'px';
    dw.style.top = Math.max(22, r.top - 8) + 'px';
    dh.style.left = Math.max(12, r.left - 16) + 'px';
    dh.style.top = (r.top + r.height / 2) + 'px';
    dw.hidden = false;
    dh.hidden = false;
  };

  // Gelbe Mittellinien, sobald das Motiv (oder die ganze Vorlage) mittig sitzt
  P.snap = function (list) {
    if (!Array.isArray(list)) list = [list];
    var pa = this.printArea();
    var r = this.unionRect(list);
    var mx = r.left + r.width / 2, my = r.top + r.height / 2;
    var cx = pa.x + pa.w / 2, cy = pa.y + pa.h / 2;
    var th = 8;
    var sv = Math.abs(mx - cx) < th, sh = Math.abs(my - cy) < th;
    this.shiftList(list, sv ? cx - mx : 0, sh ? cy - my : 0);
    this.showGuides(sv, sh);
  };

  // Etwas über der Mitte, so wie der Kunde es sieht. Dreht das Objekt bei gedrehter Ansicht mit.
  P.centerInArea = function (o) {
    var sa = this.screenArea();
    o.setPositionByOrigin(new fabric.Point(sa.cx, sa.cy - sa.h * 0.1), 'center', 'center');
    o.setCoords();
    this.turnUpright(o);
  };

  P.addObject = function (o) {
    this.styleObject(o);
    this.canvas.add(o);
    this.canvas.setActiveObject(o);
    this.constrain(o);
    o.__pdOut = false;
    this.canvas.requestRenderAll();
  };

  P.removeObject = function (o) {
    if (!o) return;
    if (o.type === 'activeSelection') {
      var objs = o.getObjects().slice();
      this.canvas.discardActiveObject();
      this.batch = true;
      this.canvas.remove.apply(this.canvas, objs);
      this.batch = false;
      this.changed();
      this.canvas.requestRenderAll();
      this.onSelect();
      return;
    }
    this.canvas.remove(o);
    this.canvas.discardActiveObject();
    this.canvas.requestRenderAll();
    this.onSelect();
  };

  // Kopie ohne Textpfad, damit gebogener Text sauber neu aufgebaut wird
  P.duplicate = function (o) {
    var self = this;
    fabric.util.enlivenObjects([objectJson(o)], function (objs) {
      var c = objs[0];
      if (!c) return;
      if (c.pdCurve) applyCurve(c);
      c.pdGroup = null;
      c.set({ left: o.left + 20, top: o.top + 20 });
      self.addObject(c);
    });
  };

  P.fitObject = function (o, share) {
    var sa = this.screenArea();
    var maxW = sa.w * share;
    var maxH = sa.h * share;
    var s = Math.min(maxW / o.width, maxH / o.height);
    o.set({ scaleX: s, scaleY: s });
    this.centerInArea(o);
  };

  /* ---------- Verlauf ---------- */

  P.pushHistory = function () {
    var name = this.view().name;
    var h = this.history[name] || (this.history[name] = { stack: ['[]'], idx: 0 });
    var snap = JSON.stringify(serialize(this.canvas));
    if (h.stack[h.idx] === snap) return;
    h.stack = h.stack.slice(0, h.idx + 1);
    h.stack.push(snap);
    if (h.stack.length > 60) h.stack.shift();
    h.idx = h.stack.length - 1;
    this.updateHistoryButtons();
  };

  P.stepHistory = function (dir) {
    var h = this.history[this.view().name];
    if (!h) return;
    var n = h.idx + dir;
    if (n < 0 || n >= h.stack.length) return;
    h.idx = n;
    this.designs[this.view().name] = JSON.parse(h.stack[n]);
    this.loadView();
    this.persist();
  };

  P.updateHistoryButtons = function () {
    var h = this.history[this.view().name] || { stack: [], idx: 0 };
    $(this.root, '[data-pd-undo]').disabled = h.idx <= 0;
    $(this.root, '[data-pd-redo]').disabled = h.idx >= h.stack.length - 1;
  };

  /* ---------- Speichern zwischen Seiten ---------- */

  P.persist = function () {
    var self = this;
    clearTimeout(this.persistTimer);
    this.persistTimer = setTimeout(function () {
      self.saveView();
      self.writeStore();
    }, 300);
  };

  P.writeStore = function () {
    var self = this;
    var out = { views: {} };
    this.views.forEach(function (v) {
      var objs = self.designs[v.name];
      if (objs && objs.length) out.views[v.name] = { objects: objs, pa: self.printArea(v) };
    });
    var json = JSON.stringify(out);
    try { sessionStorage.setItem(STORE_KEY, json); } catch (e) { /* Speicher voll oder gesperrt */ }
    // Auch nach dem Schließen des Browsers noch da
    try { localStorage.setItem(STORE_KEY, json); } catch (e) { /* Speicher voll oder gesperrt */ }
  };

  P.restore = function () {
    if (this.loadShared()) return;
    var raw = null;
    try { raw = sessionStorage.getItem(STORE_KEY); } catch (e) { /* gesperrt */ }
    if (!raw) { try { raw = localStorage.getItem(STORE_KEY); } catch (e) { return; } }
    if (!raw) return;
    var saved;
    try { saved = JSON.parse(raw); } catch (e) { return; }
    this.applySaved(saved);
  };

  // Gespeichertes Design auf die Ansichten dieses Produkts übertragen
  P.applySaved = function (saved) {
    var self = this;
    var names = Object.keys(saved.views || {});
    names.forEach(function (name, i) {
      var target = self.views.filter(function (v) { return v.name === name; })[0];
      if (!target && i === 0) target = self.views[0];
      if (!target || self.designs[target.name]) return;
      var src = saved.views[name];
      var pa = self.printArea(target);
      var old = src.pa || pa;
      var s = pa.w / old.w;
      self.designs[target.name] = (src.objects || []).map(function (o) {
        o.left = pa.x + (o.left - old.x) * s;
        o.top = pa.y + (o.top - old.y) * s;
        o.scaleX = (o.scaleX || 1) * s;
        o.scaleY = (o.scaleY || 1) * s;
        return o;
      });
    });
  };

  P.refreshFonts = function () {
    var self = this;
    if (!document.fonts) return;
    var fams = {};
    this.canvas.getObjects().forEach(function (o) { if (o.fontFamily) fams[o.fontFamily] = 1; });
    Promise.all(Object.keys(fams).map(function (f) {
      return document.fonts.load('400 40px "' + f + '"').catch(function () {});
    })).then(function () {
      if (fabric.util.clearFabricFontCache) fabric.util.clearFabricFontCache();
      self.canvas.getObjects().forEach(function (o) {
        if (o.pdCurve) applyCurve(o);
        else if (o.initDimensions) { o.initDimensions(); o.setCoords(); }
      });
      self.canvas.requestRenderAll();
    });
  };

  /* ---------- Design teilen ---------- */

  // Geteiltes Design aus dem Link (#pd=...) laden
  P.loadShared = function () {
    var m = /[#&]pd=([A-Za-z0-9_-]+)/.exec(window.location.hash || '');
    if (!m) return false;
    var self = this;
    unpackDesign(m[1]).then(function (saved) {
      self.designs = {};
      self.history = {};
      self.applySaved(saved);
      self.loadView();
      self.renderViews();
      self.persist();
      self.notice('Geteiltes Design geladen. Du kannst es ändern oder direkt bestellen.', true);
    }).catch(function () { self.notice('Der Design-Link ist leider nicht lesbar.'); });
    return true;
  };

  // Hochgeladenes Bild dauerhaft bei Shopify ablegen: kurz in den Warenkorb legen und sofort wieder entfernen
  P.uploadForShare = function (dataUrl, name) {
    var v = this.currentVariant() || this.firstVariant();
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(dataUrl).then(function (r) { return r.blob(); }).then(function (blob) {
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', '1');
      var fname = String(name || 'bild').replace(/\.[a-z0-9]+$/i, '').replace(/[^\w-]+/g, '-') + (blob.type === 'image/jpeg' ? '.jpg' : '.png');
      fd.append('properties[_Teilen]', new File([blob], fname, { type: blob.type || 'image/png' }));
      return fetch(base + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    }).then(function (r) { return r.json(); }).then(function (item) {
      var url = item && item.properties && item.properties._Teilen;
      var clean = item && item.key ? fetch(base + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      }) : Promise.resolve();
      return clean.then(function () {
        if (!url) throw new Error('Kein Link');
        return url.indexOf('//') === 0 ? 'https:' + url : url;
      });
    });
  };

  P.shareUrl = function () {
    var u = new URL(window.location.href);
    u.hash = '';
    if (!u.searchParams.get('view')) u.searchParams.set('view', 'designer');
    return u.toString();
  };

  P.copyLink = function (url, msg) {
    var self = this;
    if (navigator.share && window.matchMedia('(max-width: 899px)').matches) {
      navigator.share({ title: this.data.title, url: url }).catch(function () {});
      return;
    }
    var fallback = function () { window.prompt('Link kopieren:', url); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { self.notice(msg, true); }, fallback);
    } else fallback();
  };

  P.shareDesign = function () {
    var self = this;
    if (this.sharing) return;
    clearTimeout(this.persistTimer);
    this.saveView();
    var views = {};
    this.views.forEach(function (v) {
      var objs = self.designs[v.name];
      if (objs && objs.length) views[v.name] = { objects: JSON.parse(JSON.stringify(objs)), pa: self.printArea(v) };
    });
    var names = Object.keys(views);
    if (!names.length) { this.copyLink(this.shareUrl(), 'Link zum Produkt kopiert.'); return; }
    this.sharing = true;
    this.notice('Dein Design wird gespeichert …', true);
    var cache = this.shareCache || (this.shareCache = {});
    var jobs = [];
    names.forEach(function (n) {
      views[n].objects.forEach(function (o) {
        if (o.type !== 'image' || typeof o.src !== 'string' || o.src.indexOf('data:') !== 0) return;
        var key = o.src.length + ':' + o.src.slice(-64);
        var job = cache[key] ? Promise.resolve(cache[key]) : self.uploadForShare(o.src, o.pdName).then(function (u) { cache[key] = u; return u; });
        jobs.push(job.then(function (u) { o.src = u; o.crossOrigin = 'anonymous'; }));
      });
    });
    Promise.all(jobs).then(function () {
      return packDesign({ v: 1, views: views });
    }).then(function (code) {
      self.sharing = false;
      self.copyLink(self.shareUrl() + '#pd=' + code, 'Link zu deinem Design kopiert. Wer ihn öffnet, sieht dein Design und kann es bestellen.');
    }).catch(function () {
      self.sharing = false;
      self.notice('Das Design konnte gerade nicht gespeichert werden. Bitte versuch es noch einmal.');
    });
  };

  /* ---------- Bildqualität ---------- */

  // Effektive Auflösung eines hochgeladenen Bildes in der aktuellen Druckgröße
  P.imageDpi = function (o) {
    if (!o || o.pdKind !== 'image') return null;
    var pa = this.printArea();
    var cm = o.getScaledWidth() / pa.w * this.view().cm_w;
    if (!cm || !o.width) return null;
    return Math.round(o.width / (cm / 2.54));
  };

  P.checkDpi = function () {
    var box = $(this.root, '[data-pd-dpi]');
    if (!box || !this.canvas) return;
    var self = this, worst = null;
    this.canvas.getObjects().forEach(function (o) {
      var d = self.imageDpi(o);
      if (d != null && (worst == null || d < worst)) worst = d;
    });
    if (worst == null || worst >= 150) { box.hidden = true; return; }
    box.hidden = false;
    box.classList.toggle('is-bad', worst < 100);
    box.textContent = (worst < 100 ? 'Auflösung zu gering: ' : 'Auflösung knapp: ') +
      'Dein Bild hat in dieser Größe nur etwa ' + worst + ' dpi und kann unscharf gedruckt werden. Mach es kleiner oder lade eine größere Datei hoch.';
  };

  /* ---------- Hintergrund entfernen ---------- */

  // Prüft die vier Ecken: einfarbig und deckend = entfernbarer Hintergrund
  function detectBg(d, w, h) {
    function px(x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
    function dist(a, b) { return Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]); }
    var corners = [px(0, 0), px(w - 1, 0), px(0, h - 1), px(w - 1, h - 1)];
    if (corners.every(function (c) { return c[3] < 20; })) return { clear: true };
    var bg = null, best = -1;
    corners.forEach(function (c) {
      if (c[3] < 200) return;
      var n = corners.filter(function (x) { return x[3] >= 200 && dist(x, c) < 60; }).length;
      if (n > best) { best = n; bg = c; }
    });
    return bg && best >= 3 ? { bg: bg } : null;
  }

  function bgName(c) {
    if (c[0] > 225 && c[1] > 225 && c[2] > 225) return 'weißen';
    if (c[0] < 40 && c[1] < 40 && c[2] < 40) return 'schwarzen';
    return 'einfarbigen';
  }

  // Einfarbigen Hintergrund vom Rand aus durchsichtig machen.
  // opts.inner: dieselbe Farbe auch in eingeschlossenen Flächen entfernen (z. B. im O)
  P.removeBackground = function (o, opts) {
    var self = this;
    opts = opts || {};
    if (!o || o.pdKind !== 'image') return;
    var el = o.getElement();
    var w0 = el.naturalWidth || el.width, h0 = el.naturalHeight || el.height;
    var k = Math.min(1, 3000 / Math.max(w0, h0));
    var w = Math.max(1, Math.round(w0 * k)), h = Math.max(1, Math.round(h0 * k));
    var cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    var ctx = cv.getContext('2d');
    ctx.drawImage(el, 0, 0, w, h);
    var img;
    try { img = ctx.getImageData(0, 0, w, h); } catch (e) { this.notice('Dieses Bild kann hier nicht bearbeitet werden.'); return; }
    var d = img.data;
    var det = detectBg(d, w, h);
    if (det && det.clear && !opts.inner) { this.notice('Der Hintergrund ist schon durchsichtig.', true); return; }
    var bg = det && det.bg;
    if (!bg && opts.inner && o.pdBg) bg = o.pdBg;
    if (!bg) { this.notice('Der Hintergrund ist nicht einfarbig. Das klappt nur bei einfarbigem Hintergrund.'); return; }
    var TOL = 70, SOFT = 140;
    var seen = new Uint8Array(w * h), stack = [], removed = 0;
    for (var x = 0; x < w; x++) { stack.push(x, (h - 1) * w + x); }
    for (var y = 0; y < h; y++) { stack.push(y * w, y * w + w - 1); }
    while (stack.length) {
      var p = stack.pop();
      if (seen[p]) continue;
      seen[p] = 1;
      var i = p * 4;
      if (d[i + 3] < 20) { d[i + 3] = 0; }
      else {
        var dd = Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]);
        if (dd > SOFT) continue;
        if (dd > TOL) { d[i + 3] = Math.round(d[i + 3] * (dd - TOL) / (SOFT - TOL)); continue; }
        d[i + 3] = 0;
        removed++;
      }
      var px0 = p % w;
      if (px0 > 0) stack.push(p - 1);
      if (px0 < w - 1) stack.push(p + 1);
      if (p >= w) stack.push(p - w);
      if (p < w * (h - 1)) stack.push(p + w);
    }
    var inner = 0;
    if (opts.inner) {
      for (var q = 0; q < w * h; q++) {
        if (seen[q]) continue;
        var j = q * 4;
        if (d[j + 3] < 20) continue;
        var dj = Math.abs(d[j] - bg[0]) + Math.abs(d[j + 1] - bg[1]) + Math.abs(d[j + 2] - bg[2]);
        if (dj <= TOL) { d[j + 3] = 0; inner++; }
        else if (dj <= SOFT) d[j + 3] = Math.round(d[j + 3] * (dj - TOL) / (SOFT - TOL));
      }
    }
    if (removed + inner < w * h * (opts.inner ? 0.001 : 0.01)) {
      this.notice(opts.inner ? 'Keine weiteren Flächen in der Hintergrundfarbe gefunden.' : 'Am Rand wurde kein einfarbiger Hintergrund gefunden.');
      return;
    }
    ctx.putImageData(img, 0, 0);
    var sx = o.scaleX * o.width, sy = o.scaleY * o.height;
    o.setSrc(cv.toDataURL('image/png'), function () {
      o.set({ scaleX: sx / o.width, scaleY: sy / o.height, pdNatW: o.width, pdBg: bg.slice(0, 3) });
      o.setCoords();
      self.canvas.requestRenderAll();
      self.canvas.fire('object:modified', { target: o });
      self.bgOfferDone(o, opts.inner);
      self.notice('Hintergrund entfernt. Dein Logo wird jetzt scharf nachgezeichnet …', true);
      setTimeout(function () {
        self.vectorizeImage(o).then(function (ok) {
          self.notice(ok ? 'Hintergrund entfernt und Logo als scharfe Vektorgrafik nachgezeichnet. Mit Rückgängig holst du das Original zurück.'
            : 'Hintergrund entfernt. Das Bild hat zu viele Farbverläufe (Foto) und bleibt deshalb ein Bild.', true);
        });
      }, 30);
    });
  };

  // Nach dem Hochladen: Kasten im Upload-Bereich, wenn das Bild einen
  // einfarbigen Hintergrund hat. Ein Klick macht ihn durchsichtig.
  P.offerBgRemoval = function (o) {
    var el = o.getElement();
    var w0 = el.naturalWidth || el.width, h0 = el.naturalHeight || el.height;
    var k = Math.min(1, 400 / Math.max(w0, h0));
    var w = Math.max(1, Math.round(w0 * k)), h = Math.max(1, Math.round(h0 * k));
    var cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    var ctx = cv.getContext('2d');
    ctx.drawImage(el, 0, 0, w, h);
    var det;
    try { det = detectBg(ctx.getImageData(0, 0, w, h).data, w, h); } catch (e) { return; }
    if (!det) { this.hideBgOffer(); return; }
    var box = this.bgOfferBox();
    this.bgTarget = o;
    var go = box.querySelector('[data-pd-bg-go]');
    if (det.clear) {
      box.querySelector('[data-pd-bg-text]').textContent = 'Dein Logo hat schon keinen Hintergrund. Sollen wir es als scharfe Vektorgrafik nachzeichnen, damit die Kanten nicht verpixelt sind?';
      go.textContent = 'Scharf nachzeichnen';
      go.dataset.mode = 'trace';
      box.querySelector('[data-pd-bg-no]').textContent = 'Nein, so lassen';
    } else {
      box.querySelector('[data-pd-bg-text]').textContent = 'Dein Bild hat einen ' + bgName(det.bg) + ' Hintergrund. Soll er weg? Danach zeichnen wir dein Logo als scharfe Vektorgrafik nach.';
      go.textContent = 'Hintergrund entfernen';
      go.dataset.mode = 'bg';
      box.querySelector('[data-pd-bg-no]').textContent = 'Nein, Hintergrund behalten';
    }
    go.hidden = false;
    box.hidden = false;
  };

  P.bgOfferBox = function () {
    var box = $(this.root, '[data-pd-bg-offer]');
    if (box) return box;
    if (!document.getElementById('pd-bg-offer-css')) {
      var st = document.createElement('style');
      st.id = 'pd-bg-offer-css';
      st.textContent = '.pd__bg-offer{border:1px solid #e3e3e3;border-radius:10px;padding:12px;margin:0 0 12px;background:#fafafa;font-size:13px;line-height:1.4}' +
        '.pd__bg-offer[hidden]{display:none}.pd__bg-offer p{margin:0 0 10px}' +
        '.pd__bg-offer .pd__btn{width:100%;margin:0 0 6px}.pd__bg-offer .pd__bg-link{background:none;border:0;padding:4px 0;color:inherit;text-decoration:underline;cursor:pointer;font-size:12px}';
      document.head.appendChild(st);
    }
    box = document.createElement('div');
    box.className = 'pd__bg-offer';
    box.setAttribute('data-pd-bg-offer', '');
    box.hidden = true;
    box.innerHTML = '<p data-pd-bg-text></p>' +
      '<button type="button" class="pd__btn pd__btn--dark" data-pd-bg-go>Hintergrund entfernen</button>' +
      '<button type="button" class="pd__bg-link" data-pd-bg-no>Nein, Hintergrund behalten</button>';
    var self = this;
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var o = self.bgTarget;
      if (!o || !self.canvas.getObjects().includes(o)) { self.hideBgOffer(); return; }
      if (b.hasAttribute('data-pd-bg-go') && b.dataset.mode === 'trace') {
        self.hideBgOffer();
        self.notice('Dein Logo wird scharf nachgezeichnet …', true);
        setTimeout(function () {
          self.vectorizeImage(o).then(function (ok) {
            self.notice(ok ? 'Logo als scharfe Vektorgrafik nachgezeichnet. Mit Rückgängig holst du das Original zurück.'
              : 'Das Bild hat zu viele Farbverläufe (Foto) und bleibt deshalb ein Bild.', true);
          });
        }, 30);
      } else if (b.hasAttribute('data-pd-bg-go')) self.removeBackground(o, { inner: true });
      else self.hideBgOffer();
    });
    var anchor = $(this.root, '[data-pd-upload-list]');
    anchor.parentNode.insertBefore(box, anchor);
    return box;
  };

  P.bgOfferDone = function (o, inner) {
    var box = $(this.root, '[data-pd-bg-offer]');
    if (!box || box.hidden || this.bgTarget !== o) return;
    this.hideBgOffer();
  };

  P.hideBgOffer = function () {
    var box = $(this.root, '[data-pd-bg-offer]');
    if (box) box.hidden = true;
    this.bgTarget = null;
  };

  // Bildnachzeichner wie in Illustrator: freigestelltes Logo wird zu
  // Vektorpfaden und ersetzt das Bild auf dem Produkt (Lage und Größe gleich).
  // Fotos bleiben Bilder. Liefert true, wenn nachgezeichnet wurde.
  P.vectorizeImage = function (o) {
    var self = this;
    var el = o && o.getElement && o.getElement();
    var W = el && (el.naturalWidth || el.width), H = el && (el.naturalHeight || el.height);
    if (!W || !H) return Promise.resolve(false);
    // große Bilder auf 1200 px begrenzen (reicht für Logos, bleibt schnell)
    var f = Math.min(1, 1200 / Math.max(W, H));
    var tw = Math.max(1, Math.round(W * f)), th = Math.max(1, Math.round(H * f));
    var cv = document.createElement('canvas');
    cv.width = tw; cv.height = th;
    var ctx = cv.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(el, 0, 0, tw, th);
    var d;
    try { d = ctx.getImageData(0, 0, tw, th).data; } catch (e) { return Promise.resolve(false); }
    // Farben nur aus dem Inneren der Flächen bestimmen (ohne Kantenpixel mit Mischfarbe)
    var core = new Uint8ClampedArray(d.length);
    for (var y = 1; y < th - 1; y++) {
      for (var x = 1; x < tw - 1; x++) {
        var p = (y * tw + x) * 4;
        if (d[p + 3] > 250 && d[p - 1] > 250 && d[p + 7] > 250 && d[p - tw * 4 + 3] > 250 && d[p + tw * 4 + 3] > 250) {
          var q = p;
          var same = [p - 4, p + 4, p - tw * 4, p + tw * 4].every(function (n) {
            return Math.abs(d[n] - d[q]) + Math.abs(d[n + 1] - d[q + 1]) + Math.abs(d[n + 2] - d[q + 2]) < 30;
          });
          if (same) { core[p] = d[p]; core[p + 1] = d[p + 1]; core[p + 2] = d[p + 2]; core[p + 3] = 255; }
        }
      }
    }
    var pal = logoPalette(core, 0.03);
    if (!pal) return Promise.resolve(false);
    var layers;
    try { layers = Vec.trace(d, tw, th, pal, o.pdBg || null); } catch (e) { console.warn('Nachzeichnen', e); return Promise.resolve(false); }
    if (!layers.length) return Promise.resolve(false);
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + tw + '" height="' + th + '" viewBox="0 0 ' + tw + ' ' + th + '">' +
      layers.map(function (l) { return '<path fill="' + l.color + '" fill-rule="evenodd" d="' + l.d + '"/>'; }).join('') + '</svg>';
    return new Promise(function (resolve) {
      fabric.loadSVGFromString(svg, function (objs) {
        if (!objs || !objs.length || !self.canvas.getObjects().includes(o)) { resolve(false); return; }
        var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        objs.forEach(function (ob) {
          var r = ob.getBoundingRect(true, true);
          minX = Math.min(minX, r.left); minY = Math.min(minY, r.top);
          maxX = Math.max(maxX, r.left + r.width); maxY = Math.max(maxY, r.top + r.height);
        });
        var g = objs.length === 1 ? objs[0] : new fabric.Group(objs);
        // Mittelpunkt der Pfade im Bild-Koordinatensystem, dann wie das Bild transformieren
        var local = new fabric.Point((minX + maxX) / 2 * W / tw - o.width / 2, (minY + maxY) / 2 * H / th - o.height / 2);
        var world = fabric.util.transformPoint(local, o.calcTransformMatrix());
        g.set({ scaleX: o.scaleX * W / tw, scaleY: o.scaleY * H / th, angle: o.angle, flipX: o.flipX, flipY: o.flipY,
          opacity: o.opacity, pdKind: 'svg', pdName: o.pdName || 'Logo' });
        g.setPositionByOrigin(world, 'center', 'center');
        g.setCoords();
        var c = self.canvas, idx = c.getObjects().indexOf(o);
        self.batch = true;
        c.remove(o);
        self.styleObject(g);
        c.insertAt(g, idx);
        self.batch = false;
        c.setActiveObject(g);
        self.constrain(g);
        self.changed();
        c.requestRenderAll();
        resolve(true);
      });
    });
  };

  /* Bildnachzeichner (eigene Umsetzung, ohne Fremdbibliothek).
     1. Deckung je Logofarbe aus dem Bild berechnen. Kantenpixel sind
        Mischfarben aus Logo und Hintergrund; sie werden zurückgerechnet
        (Entmischung), damit die Kante auf Bruchteile eines Pixels genau sitzt.
     2. Weich hochrechnen und leicht weichzeichnen (JPG-Rauschen weg).
     3. Konturen auf der 50-%-Linie suchen (Marching Squares, subpixelgenau).
     4. Ecken erkennen, dazwischen glatte Bézierkurven anpassen (Schneider).
     Ergebnis: Pfade in Bildpixeln des Originals. */
  var Vec = (function () {
    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    // Catmull-Rom-Hochrechnung eines Feldes (getrennt nach x und y)
    function upsample(F, w, h, s) {
      if (s === 1) return { F: F, w: w, h: h };
      var W = Math.round(w * s), H = Math.round(h * s);
      function cr(p0, p1, p2, p3, t) {
        return p1 + 0.5 * t * (p2 - p0 + t * (2 * p0 - 5 * p1 + 4 * p2 - p3 + t * (3 * (p1 - p2) + p3 - p0)));
      }
      var T = new Float32Array(W * h), O = new Float32Array(W * H), x, y;
      var ix = new Int32Array(W), fx = new Float32Array(W);
      for (x = 0; x < W; x++) { var sx = (x + 0.5) / s - 0.5; ix[x] = Math.floor(sx); fx[x] = sx - ix[x]; }
      for (y = 0; y < h; y++) {
        var row = y * w;
        for (x = 0; x < W; x++) {
          var i = ix[x];
          var a = F[row + Math.max(0, Math.min(w - 1, i - 1))], b = F[row + Math.max(0, Math.min(w - 1, i))],
            c = F[row + Math.max(0, Math.min(w - 1, i + 1))], d = F[row + Math.max(0, Math.min(w - 1, i + 2))];
          T[y * W + x] = cr(a, b, c, d, fx[x]);
        }
      }
      for (y = 0; y < H; y++) {
        var sy = (y + 0.5) / s - 0.5, j = Math.floor(sy), t = sy - j;
        var r0 = Math.max(0, Math.min(h - 1, j - 1)) * W, r1 = Math.max(0, Math.min(h - 1, j)) * W,
          r2 = Math.max(0, Math.min(h - 1, j + 1)) * W, r3 = Math.max(0, Math.min(h - 1, j + 2)) * W;
        for (x = 0; x < W; x++) O[y * W + x] = cr(T[r0 + x], T[r1 + x], T[r2 + x], T[r3 + x], t);
      }
      return { F: O, w: W, h: H };
    }

    function gauss(F, w, h, sigma) {
      if (sigma < 0.3) return F;
      var r = Math.ceil(sigma * 2.5), k = [], sum = 0, i, x, y;
      for (i = -r; i <= r; i++) { var v = Math.exp(-i * i / (2 * sigma * sigma)); k.push(v); sum += v; }
      for (i = 0; i < k.length; i++) k[i] /= sum;
      var T = new Float32Array(w * h), O = new Float32Array(w * h);
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        var acc = 0;
        for (i = -r; i <= r; i++) { var xx = x + i; if (xx >= 0 && xx < w) acc += F[y * w + xx] * k[i + r]; }
        T[y * w + x] = acc;
      }
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        var acc2 = 0;
        for (i = -r; i <= r; i++) { var yy = y + i; if (yy >= 0 && yy < h) acc2 += T[yy * w + x] * k[i + r]; }
        O[y * w + x] = acc2;
      }
      return O;
    }

    // Konturen auf Höhe 0.5; Feld bekommt einen leeren Rand, damit alles geschlossen ist
    function contours(F, w, h) {
      var W = w + 2, H = h + 2, G = new Float32Array(W * H), x, y;
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) G[(y + 1) * W + x + 1] = F[y * w + x];
      var L = 0.5;
      // Kanten-IDs: horizontale Kante (x,y)-(x+1,y) = 2*(y*W+x), vertikale (x,y)-(x,y+1) = 2*(y*W+x)+1
      var pt = {}, next = {};
      function cross(e) {
        if (pt[e]) return;
        var base = e >> 1, ex = base % W, ey = (base / W) | 0, v0 = G[base], v1, px, py;
        if (e & 1) { v1 = G[base + W]; var t = (L - v0) / (v1 - v0); px = ex; py = ey + t; }
        else { v1 = G[base + 1]; var t2 = (L - v0) / (v1 - v0); px = ex + t2; py = ey; }
        pt[e] = [px - 1, py - 1];
      }
      function link(a, b) { cross(a); cross(b); next[a] = b; }
      for (y = 0; y < H - 1; y++) for (x = 0; x < W - 1; x++) {
        var i0 = y * W + x;
        var tl = G[i0] > L, tr = G[i0 + 1] > L, br = G[i0 + W + 1] > L, bl = G[i0 + W] > L;
        var c = (tl ? 8 : 0) | (tr ? 4 : 0) | (br ? 2 : 0) | (bl ? 1 : 0);
        if (c === 0 || c === 15) continue;
        var top = 2 * i0, bot = 2 * (i0 + W), left = 2 * i0 + 1, right = 2 * (i0 + 1) + 1;
        // Richtung so, dass das Innere immer rechts liegt (gleichmäßige Orientierung)
        switch (c) {
          case 1: link(bot, left); break;
          case 2: link(right, bot); break;
          case 3: link(right, left); break;
          case 4: link(top, right); break;
          case 6: link(top, bot); break;
          case 7: link(top, left); break;
          case 8: link(left, top); break;
          case 9: link(bot, top); break;
          case 11: link(right, top); break;
          case 12: link(left, right); break;
          case 13: link(bot, right); break;
          case 14: link(left, bot); break;
          case 5: case 10:
            var mid = (G[i0] + G[i0 + 1] + G[i0 + W] + G[i0 + W + 1]) / 4 > L;
            if (c === 5) { if (mid) { link(top, left); link(bot, right); } else { link(bot, left); link(top, right); } }
            else { if (mid) { link(left, bot); link(right, top); } else { link(left, top); link(right, bot); } }
            break;
        }
      }
      var loops = [], seen = {};
      Object.keys(next).forEach(function (k) {
        var s = +k;
        if (seen[s]) return;
        var loop = [], e = s, guard = 0;
        while (e !== undefined && !seen[e] && guard++ < 1e7) { seen[e] = 1; loop.push(pt[e]); e = next[e]; }
        if (loop.length > 2) loops.push(loop);
      });
      return loops;
    }

    function area(p) {
      var a = 0;
      for (var i = 0, n = p.length; i < n; i++) { var q = p[(i + 1) % n]; a += p[i][0] * q[1] - q[0] * p[i][1]; }
      return a / 2;
    }

    // Punkte auf gleichmäßigen Abstand bringen (Kontur hat sehr kurze und lange Stücke)
    function resample(p, step) {
      var out = [p[0]], acc = 0, n = p.length;
      for (var i = 1; i <= n; i++) {
        var a = p[i - 1], b = p[i % n], dx = b[0] - a[0], dy = b[1] - a[1], d = Math.hypot(dx, dy), t = 0;
        while (acc + d * (1 - t) >= step) {
          t += (step - acc) / d; acc = 0;
          out.push([a[0] + dx * t, a[1] + dy * t]);
        }
        acc += d * (1 - t);
      }
      if (out.length > 3 && Math.hypot(out[out.length - 1][0] - out[0][0], out[out.length - 1][1] - out[0][1]) < step * 0.5) out.pop();
      return out;
    }

    // Ecken: Knick zwischen Richtung nach hinten und nach vorne (über k Punkte)
    // Ecken: Knick zwischen Richtung nach hinten und nach vorne. Geprüft auf
    // kurzer (genaue Lage) und langer Strecke (Treppenstufen sind dort gerade).
    function angles(p, k) {
      var n = p.length, ang = new Float32Array(n);
      for (var i = 0; i < n; i++) {
        var a = p[(i - k + n) % n], b = p[i], c = p[(i + k) % n];
        var v1x = b[0] - a[0], v1y = b[1] - a[1], v2x = c[0] - b[0], v2y = c[1] - b[1];
        var cos = (v1x * v2x + v1y * v2y) / (Math.hypot(v1x, v1y) * Math.hypot(v2x, v2y) || 1);
        ang[i] = Math.acos(Math.max(-1, Math.min(1, cos))) * 180 / Math.PI;
      }
      return ang;
    }
    function corners(p, kS, kL, minDeg) {
      var n = p.length, res = [], i;
      if (n < 4 * kS) return res;
      var aS = angles(p, kS), aL = angles(p, Math.min(kL, (n / 4) | 0));
      for (i = 0; i < n; i++) {
        if (aS[i] < minDeg || aL[i] < minDeg * 0.8) continue;
        var best = true;
        for (var j = -kS; j <= kS && best; j++) {
          var v = aS[(i + j + n) % n];
          if (j && (v > aS[i] || (v === aS[i] && j < 0))) best = false;
        }
        if (best) res.push(i);
      }
      return res;
    }

    /* ---- Kurvenanpassung nach Philip J. Schneider (Graphics Gems, 1990) ---- */
    function sub(a, b) { return [a[0] - b[0], a[1] - b[1]]; }
    function add(a, b) { return [a[0] + b[0], a[1] + b[1]]; }
    function mul(a, s) { return [a[0] * s, a[1] * s]; }
    function dot(a, b) { return a[0] * b[0] + a[1] * b[1]; }
    function norm(a) { var l = Math.hypot(a[0], a[1]) || 1; return [a[0] / l, a[1] / l]; }
    function bez(c, t) {
      var mt = 1 - t;
      return add(add(mul(c[0], mt * mt * mt), mul(c[1], 3 * mt * mt * t)), add(mul(c[2], 3 * mt * t * t), mul(c[3], t * t * t)));
    }
    function chordParams(pts) {
      var u = [0];
      for (var i = 1; i < pts.length; i++) u.push(u[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
      var L = u[u.length - 1] || 1;
      return u.map(function (v) { return v / L; });
    }
    function generate(pts, u, t1, t2) {
      var first = pts[0], last = pts[pts.length - 1], C = [[0, 0], [0, 0]], X = [0, 0];
      for (var i = 0; i < pts.length; i++) {
        var t = u[i], mt = 1 - t, b0 = mt * mt * mt, b1 = 3 * mt * mt * t, b2 = 3 * mt * t * t, b3 = t * t * t;
        var A1 = mul(t1, b1), A2 = mul(t2, b2);
        C[0][0] += dot(A1, A1); C[0][1] += dot(A1, A2); C[1][1] += dot(A2, A2);
        var tmp = sub(pts[i], add(add(mul(first, b0 + b1), [0, 0]), mul(last, b2 + b3)));
        X[0] += dot(A1, tmp); X[1] += dot(A2, tmp);
      }
      C[1][0] = C[0][1];
      var det = C[0][0] * C[1][1] - C[1][0] * C[0][1];
      var a1 = det ? (X[0] * C[1][1] - X[1] * C[0][1]) / det : 0;
      var a2 = det ? (C[0][0] * X[1] - C[1][0] * X[0]) / det : 0;
      var seg = Math.hypot(last[0] - first[0], last[1] - first[1]), eps = 1e-6 * seg;
      if (a1 < eps || a2 < eps || a1 > seg * 2 || a2 > seg * 2) { a1 = a2 = seg / 3; }
      return [first, add(first, mul(t1, a1)), add(last, mul(t2, a2)), last];
    }
    function maxErr(pts, c, u) {
      var m = 0, idx = (pts.length / 2) | 0;
      for (var i = 1; i < pts.length - 1; i++) {
        var d = sub(bez(c, u[i]), pts[i]), e = dot(d, d);
        if (e >= m) { m = e; idx = i; }
      }
      return [m, idx];
    }
    function reparam(pts, u, c) {
      return u.map(function (t, i) {
        var mt = 1 - t;
        var q = bez(c, t);
        var q1 = add(add(mul(sub(c[1], c[0]), 3 * mt * mt), mul(sub(c[2], c[1]), 6 * mt * t)), mul(sub(c[3], c[2]), 3 * t * t));
        var q2 = add(mul(add(sub(c[2], mul(c[1], 2)), c[0]), 6 * mt), mul(add(sub(c[3], mul(c[2], 2)), c[1]), 6 * t));
        var d = sub(q, pts[i]), num = dot(d, q1), den = dot(q1, q1) + dot(d, q2);
        return den ? Math.max(0, Math.min(1, t - num / den)) : t;
      });
    }
    function fit(pts, t1, t2, err, out, depth) {
      if (pts.length === 2) {
        var dist = Math.hypot(pts[1][0] - pts[0][0], pts[1][1] - pts[0][1]) / 3;
        out.push([pts[0], add(pts[0], mul(t1, dist)), add(pts[1], mul(t2, dist)), pts[1]]);
        return;
      }
      var u = chordParams(pts), c = generate(pts, u, t1, t2), e = maxErr(pts, c, u);
      if (e[0] < err) { out.push(c); return; }
      if (e[0] < err * 4) {
        for (var it = 0; it < 6; it++) {
          u = reparam(pts, u, c); c = generate(pts, u, t1, t2); e = maxErr(pts, c, u);
          if (e[0] < err) { out.push(c); return; }
        }
      }
      var sp = Math.max(1, Math.min(pts.length - 2, e[1]));
      if (depth > 40) { out.push(c); return; }
      var tc = norm(sub(pts[sp - 1], pts[sp + 1]));
      fit(pts.slice(0, sp + 1), t1, tc, err, out, depth + 1);
      fit(pts.slice(sp), mul(tc, -1), t2, err, out, depth + 1);
    }
    function tangentAt(pts, i, dir, k) {
      // Richtung über einige Punkte gemittelt (stabil gegen Restrauschen)
      var n = pts.length, j = Math.max(0, Math.min(n - 1, i + dir * k));
      return norm(sub(pts[j], pts[i]));
    }

    /* Kontur zwischen den Ecken glätten. Bei kleinen oder komprimierten (JPG)
       Logos wellt sich die Kante leicht; vergrößert im Druck sieht man das als
       Hubbel. Gauß mit Schrumpfausgleich (2G - GG), Ecken bleiben fest. */
    function smoothRun(pts, sig, closed) {
      var n = pts.length, r = Math.ceil(sig * 3), k = [], sum = 0, i, j;
      if (sig < 0.5 || n < 3) return pts;
      for (i = -r; i <= r; i++) { var v = Math.exp(-i * i / (2 * sig * sig)); k.push(v); sum += v; }
      for (i = 0; i < k.length; i++) k[i] /= sum;
      function at(a, i) {
        if (closed) return a[((i % n) + n) % n];
        // ungerade Spiegelung am Ende: Geraden laufen gerade in die Ecke
        if (i < 0) { var q = a[Math.min(n - 1, -i)]; return [2 * a[0][0] - q[0], 2 * a[0][1] - q[1]]; }
        if (i >= n) { var q2 = a[Math.max(0, 2 * (n - 1) - i)]; return [2 * a[n - 1][0] - q2[0], 2 * a[n - 1][1] - q2[1]]; }
        return a[i];
      }
      function blur(a) {
        var o = [];
        for (var i = 0; i < n; i++) {
          var x = 0, y = 0;
          for (var j = -r; j <= r; j++) { var q = at(a, i + j); x += q[0] * k[j + r]; y += q[1] * k[j + r]; }
          o.push([x, y]);
        }
        if (!closed) { o[0] = a[0]; o[n - 1] = a[n - 1]; }
        return o;
      }
      var g = blur(pts), gg = blur(g), out = [];
      for (i = 0; i < n; i++) out.push([2 * g[i][0] - gg[i][0], 2 * g[i][1] - gg[i][1]]);
      return out;
    }
    function smoothLoop(p, cs, sig) {
      var n = p.length;
      if (!cs.length) return smoothRun(p, Math.min(sig, n / 8), true);
      var q = p.slice();
      for (var ci = 0; ci < cs.length; ci++) {
        var a = cs[ci], len = (cs[(ci + 1) % cs.length] - a + n) % n || n, run = [];
        for (var j = 0; j <= len; j++) run.push(p[(a + j) % n]);
        var sm = smoothRun(run, Math.min(sig, len / 6), false);
        for (j = 1; j < len; j++) q[(a + j) % n] = sm[j];
      }
      return q;
    }

    function loopToPath(p, opts) {
      var n = p.length;
      var cs = corners(p, opts.kS, opts.kL, opts.cornerDeg);
      p = smoothLoop(p, cs, opts.smooth);
      var segs = [];
      if (!cs.length) {
        // runde Form (z. B. O): an einer Stelle auftrennen, Tangente beidseitig gleich
        var q = p.concat([p[0]]);
        var tc = norm(sub(p[1], p[n - 1]));
        fit(q, tc, mul(tc, -1), opts.err, segs, 0);
      } else {
        // Ecken wieder spitz machen: die Kanten davor und danach als Geraden
        // verlängern und schneiden (die Weichzeichnung hatte sie abgerundet)
        var k = opts.kS, nc = cs.length, sharp = cs.map(function (i, ci) {
          // Arme nur bis kurz vor die Nachbarecke, sonst entstehen Zacken an kurzen Kanten
          var gp = nc > 1 ? (i - cs[(ci - 1 + nc) % nc] + n) % n || n : n, gn = nc > 1 ? (cs[(ci + 1) % nc] - i + n) % n || n : n;
          var res = { pt: p[i], tin: null, tout: null };
          var aN = Math.min(k, Math.floor(gp * 0.3)), aF = Math.min(3 * k, Math.floor(gp * 0.85));
          var bN = Math.min(k, Math.floor(gn * 0.3)), bF = Math.min(3 * k, Math.floor(gn * 0.85));
          var A = p[(i - aN + n) % n], A2 = p[(i - aF + n) % n], B = p[(i + bN) % n], B2 = p[(i + bF) % n];
          res.tin = norm(sub(p[i], p[(i - Math.max(1, aF) + n) % n]));
          res.tout = norm(sub(p[(i + Math.max(1, bF)) % n], p[i]));
          if (aF - aN < 2 || bF - bN < 2) return res;
          var d1 = norm(sub(A, A2)), d2 = norm(sub(B2, B));
          res.tin = d1; res.tout = d2;
          var den = d1[0] * d2[1] - d1[1] * d2[0];
          if (Math.abs(den) > 0.15) {
            var t = ((B[0] - A[0]) * d2[1] - (B[1] - A[1]) * d2[0]) / den;
            var X = add(A, mul(d1, t));
            if (t > 0 && Math.hypot(X[0] - p[i][0], X[1] - p[i][1]) < opts.sharpMax) res.pt = X;
          }
          return res;
        });
        for (var ci = 0; ci < cs.length; ci++) {
          var a = cs[ci], b = cs[(ci + 1) % cs.length], len = (b - a + n) % n || n;
          var m = Math.min(k, Math.floor(len * 0.3));
          var part = [sharp[ci].pt];
          for (var j = m; j <= len - m; j++) part.push(p[(a + j) % n]);
          part.push(sharp[(ci + 1) % cs.length].pt);
          if (part.length < 3) { fit(part, sharp[ci].tout, mul(sharp[(ci + 1) % cs.length].tin, -1), opts.err, segs, 0); continue; }
          fit(part, sharp[ci].tout, mul(sharp[(ci + 1) % cs.length].tin, -1), opts.err, segs, 0);
        }
      }
      if (!segs.length) return '';
      var f = function (v) { return (Math.round(v * 100) / 100).toString(); };
      var d = 'M' + f(segs[0][0][0]) + ' ' + f(segs[0][0][1]);
      segs.forEach(function (c) {
        d += 'C' + f(c[1][0]) + ' ' + f(c[1][1]) + ' ' + f(c[2][0]) + ' ' + f(c[2][1]) + ' ' + f(c[3][0]) + ' ' + f(c[3][1]);
      });
      return d + 'Z';
    }

    // Hat die Ebene weiche (geglättete) Kanten? Harte Treppenkanten (z. B. alte
    // GIF-Logos) brauchen mehr Weichzeichnung, sonst wird jede Stufe zur Ecke.
    function isAliased(F, w, h) {
      var edge = 0, soft = 0;
      for (var y = 1; y < h - 1; y++) for (var x = 1; x < w - 1; x++) {
        var v = F[y * w + x];
        if (v < 0.5) continue;
        var l = F[y * w + x - 1], r = F[y * w + x + 1], u = F[(y - 1) * w + x], d = F[(y + 1) * w + x];
        if (l < 0.5 || r < 0.5 || u < 0.5 || d < 0.5) {
          edge++;
          if ([l, r, u, d, v].some(function (q) { return q > 0.12 && q < 0.88; })) soft++;
        }
      }
      return edge > 50 && soft / edge < 0.35;
    }

    /* data: RGBA (Uint8ClampedArray), w, h; pal: [{r,g,b}] Logofarben;
       bg: [r,g,b] ursprünglicher Hintergrund oder null (Bild schon freigestellt).
       Liefert [{color:'rgb(..)', d:'...'}] in Pixeln des übergebenen Bildes. */
    function trace(data, w, h, pal, bg) {
      // Platzhalter "durchsichtig" (a = 0) ist keine Logofarbe. Als Ebene
      // mitgerechnet erzeugt er schwarze Krümel und kleine Hubbel an den Kanten.
      pal = pal.filter(function (P) { return P.a !== 0; });
      // fast gleiche Logofarben zusammenlegen (sonst zwei Schwarz-Ebenen)
      pal = pal.reduce(function (acc, P) {
        if (!acc.some(function (Q) { return Math.abs(P.r - Q.r) + Math.abs(P.g - Q.g) + Math.abs(P.b - Q.b) < 60; })) acc.push(P);
        return acc;
      }, []);
      var n = w * h, K = pal.length, i, c;
      var fields = [];
      for (c = 0; c < K; c++) fields.push(new Float32Array(n));
      // Kantenpixel sind Mischungen aus zwei Farben (Logofarbe mit Hintergrund
      // oder zwei Logofarben). Für jedes Pixel das passende Paar und den Anteil suchen.
      // Gerechnet wird in Helligkeit + abgeschwächter Farbe: JPG speichert die
      // Farbe nur in halber Auflösung, die Helligkeit aber scharf. So folgt die
      // Kante der Helligkeit und wellt sich nicht entlang der JPG-Blöcke.
      var CW = 0.35;
      function yc(r, g, b) {
        var Y = 0.299 * r + 0.587 * g + 0.114 * b;
        return [Y, CW * (b - Y) * 0.564, CW * (r - Y) * 0.713];
      }
      var src = pal.map(function (P) { return yc(P.r, P.g, P.b); });
      if (bg) src.push(yc(bg[0], bg[1], bg[2]));
      var S = src.length, pairs = [];
      for (var p1 = 0; p1 < S; p1++) for (var p2 = p1 + 1; p2 < S; p2++) {
        var ex = src[p2][0] - src[p1][0], ey = src[p2][1] - src[p1][1], ez = src[p2][2] - src[p1][2];
        pairs.push([p1, p2, ex, ey, ez, ex * ex + ey * ey + ez * ez || 1]);
      }
      // Welche Logofarben kommen in der Nähe (2 Pixel) wirklich als reine Farbe
      // vor? Nur diese dürfen eine Kante bilden. Sonst entstehen an grünen Kanten
      // blaue Krümel, weil die Mischfarbe zufällig auch zu Blau passt.
      var near = new Int32Array(n), tmp = new Int32Array(n), x, y, rr = 2;
      for (i = 0; i < n; i++) {
        if (data[i * 4 + 3] < 250) continue;
        var pc = yc(data[i * 4], data[i * 4 + 1], data[i * 4 + 2]);
        for (c = 0; c < K; c++) {
          var e1 = pc[0] - src[c][0], e2 = pc[1] - src[c][1], e3 = pc[2] - src[c][2];
          if (e1 * e1 + e2 * e2 + e3 * e3 < 300) { near[i] |= 1 << c; break; }
        }
      }
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        var m = 0;
        for (var dx = -rr; dx <= rr; dx++) { var xx = x + dx; if (xx >= 0 && xx < w) m |= near[y * w + xx]; }
        tmp[y * w + x] = m;
      }
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        var m2 = 0;
        for (var dy = -rr; dy <= rr; dy++) { var yy = y + dy; if (yy >= 0 && yy < h) m2 |= tmp[yy * w + x]; }
        near[y * w + x] = m2 | (1 << K); // Hintergrund ist immer erlaubt
      }
      for (i = 0; i < n; i++) {
        var a = data[i * 4 + 3] / 255;
        if (a < 0.02) continue;
        var ok = near[i] === (1 << K) ? -1 : near[i];
        var px = yc(data[i * 4], data[i * 4 + 1], data[i * 4 + 2]), r = px[0], g = px[1], b = px[2];
        var bi = 0, bj = 0, bt = 0, bestErr = Infinity;
        for (c = 0; c < S; c++) {
          if (!(ok & (1 << c))) continue;
          var dr = r - src[c][0], dg = g - src[c][1], db = b - src[c][2], e0 = dr * dr + dg * dg + db * db;
          if (e0 < bestErr) { bestErr = e0; bi = c; bj = c; bt = 0; }
        }
        if (bestErr > 20) {
          for (var q = 0; q < pairs.length; q++) {
            var Q = pairs[q], o0 = src[Q[0]];
            if (!(ok & (1 << Q[0])) || !(ok & (1 << Q[1]))) continue;
            var t = ((r - o0[0]) * Q[2] + (g - o0[1]) * Q[3] + (b - o0[2]) * Q[4]) / Q[5];
            if (t <= 0 || t >= 1) continue;
            var mx = o0[0] + t * Q[2] - r, my = o0[1] + t * Q[3] - g, mz = o0[2] + t * Q[4] - b, er = mx * mx + my * my + mz * mz;
            if (er < bestErr) { bestErr = er; bi = Q[0]; bj = Q[1]; bt = t; }
          }
        }
        // Anteil von bi ist (1 - bt), von bj ist bt; Hintergrund (Index K) zählt nicht
        if (bi < K) fields[bi][i] += (1 - bt) * (bg ? 1 : a);
        if (bj < K && bj !== bi) fields[bj][i] += bt * (bg ? 1 : a);
      }
      // Kleine Logos hochrechnen, damit feine Rundungen erhalten bleiben
      var s = Math.max(1, Math.min(4, Math.round(1000 / Math.max(w, h))));
      var areas = fields.map(function (F) { var t = 0; for (var j = 0; j < n; j++) t += F[j]; return t; });
      var order = pal.map(function (_, j) { return j; }).sort(function (x, y) { return areas[y] - areas[x]; });
      // Untere Farben reichen unter die oberen, damit keine Haarlinien-Lücken entstehen
      var out = [], cum = new Float32Array(n);
      for (var oi = order.length - 1; oi >= 0; oi--) {
        var F = fields[order[oi]];
        for (i = 0; i < n; i++) cum[i] = Math.min(1, cum[i] + F[i]);
        out.unshift({ idx: order[oi], F: new Float32Array(cum) });
      }
      var res = [];
      out.forEach(function (o) {
        if (areas[o.idx] < 4) return;
        var sig = isAliased(o.F, w, h) ? 1.1 : 0.55;
        var U = upsample(o.F, w, h, s);
        var G = gauss(U.F, U.w, U.h, sig * s);
        var loops = contours(G, U.w, U.h);
        var opts = { kS: Math.max(2, Math.round(1.2 * s / 0.5)), kL: Math.max(4, Math.round(2.6 * s / 0.5)), cornerDeg: 50, tanK: Math.max(2, Math.round(s)), sharpMax: 2.5 * s,
          err: Math.pow(0.35 * s, 2), smooth: 1.2 * 2 * s };
        var d = '';
        loops.forEach(function (lp) {
          if (Math.abs(area(lp)) < Math.pow(1.2 * s, 2)) return; // Krümel weg
          var rp = resample(lp, 0.5);
          if (rp.length < 4) return;
          d += loopToPath(rp, opts);
        });
        if (!d) return;
        // zurück in Pixel des Eingabebildes (Feldpunkt i liegt in der Pixelmitte i + 0,5)
        d = d.replace(/-?\d+(\.\d+)?/g, function (v) { return (Math.round((parseFloat(v) + 0.5) / s * 100) / 100).toString(); });
        var P = pal[o.idx];
        res.push({ color: 'rgb(' + P.r + ',' + P.g + ',' + P.b + ')', d: d });
      });
      return res;
    }
    return { trace: trace };
  })();

  /* ---------- Motiv-Bibliothek ---------- */

  P.loadMotifLib = function () {
    var box = $(this.root, '[data-pd-motif-lib]');
    if (!box || this.motifLib) return;
    var self = this;
    this.motifLib = 'loading';
    fetch(box.dataset.src).then(function (r) { return r.json(); }).then(function (lib) {
      self.motifLib = lib;
      box.innerHTML = '';
      (lib.categories || []).forEach(function (cat) {
        var h = document.createElement('p');
        h.className = 'pd__label pd__motif-cat';
        h.textContent = cat.name;
        box.appendChild(h);
        var ul = document.createElement('ul');
        ul.className = 'pd__motif-list';
        cat.items.forEach(function (it) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pd__motif';
          b.title = it.name;
          var img = document.createElement('img');
          img.alt = it.name;
          img.width = 120; img.height = 120;
          img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(it.svg);
          b.appendChild(img);
          b.addEventListener('click', function () { self.addLibMotif(it); });
          li.appendChild(b);
          ul.appendChild(li);
        });
        box.appendChild(ul);
      });
      if (lib.license) {
        var lic = document.createElement('p');
        lic.className = 'pd__motif-license';
        lic.textContent = lib.license;
        box.appendChild(lic);
      }
    }).catch(function () {
      self.motifLib = null;
      box.innerHTML = '<p class="pd__hint">Die Motive konnten nicht geladen werden.</p>';
    });
  };

  P.addLibMotif = function (it) {
    var self = this;
    fabric.loadSVGFromString(it.svg, function (objs, opts) {
      if (!objs || !objs.length) return;
      var g = fabric.util.groupSVGElements(objs, opts);
      g.set({ pdKind: 'motif', pdName: it.name, pdColor: '#111111' });
      self.fitObject(g, 0.5);
      self.addObject(g);
      var dc = self.defaultTextColor();
      if (dc !== '#000000') { self.setMotifColor(dc); self.syncToolbar(); }
      if (window.matchMedia('(max-width: 899px)').matches) self.closeTool();
    });
  };

  // Vektor-Motive lassen sich einfärben, Fotos nicht
  P.setMotifColor = function (c) {
    var o = this.canvas.getActiveObject();
    if (!o || o.pdKind !== 'motif' || o.type === 'image' || !c) return;
    (o.getObjects ? o.getObjects() : [o]).forEach(function (ch) {
      if (ch.stroke && ch.stroke !== 'none') ch.set('stroke', c);
      if (ch.fill && ch.fill !== 'none' && ch.fill !== 'transparent') ch.set('fill', c);
    });
    o.set('pdColor', c);
    o.dirty = true;
    this.canvas.requestRenderAll();
    this.canvas.fire('object:modified', { target: o });
  };

  /* ---------- Werkzeuge ---------- */

  P.openTool = function (tool) {
    var fly = $(this.root, '[data-pd-flyout]');
    var already = !fly.hidden && fly.dataset.tool === tool;
    $$(this.root, '[data-pd-tool]').forEach(function (b) { b.classList.toggle('is-active', !already && b.dataset.pdTool === tool); });
    if (already) { this.closeTool(); return; }
    fly.hidden = false;
    fly.dataset.tool = tool;
    $(this.root, '[data-pd-stage]').classList.add('has-flyout');
    this.layout();
    var btn = $(this.root, '[data-pd-tool="' + tool + '"] span');
    $(this.root, '[data-pd-flyout-title]').textContent = btn ? btn.textContent : '';
    $$(this.root, '[data-pd-panel]').forEach(function (p) { p.hidden = p.dataset.pdPanel !== tool; });
    if (tool === 'motifs') this.loadMotifLib();
    if (tool === 'text') {
      var input = $(this.root, '[data-pd-text-input]');
      var t = this.activeText();
      input.value = t ? t.text : '';
      if (!window.matchMedia('(max-width: 899px)').matches) setTimeout(function () { input.focus(); }, 50);
    }
  };

  P.closeTool = function () {
    var fly = $(this.root, '[data-pd-flyout]');
    fly.hidden = true;
    fly.dataset.tool = '';
    $(this.root, '[data-pd-stage]').classList.remove('has-flyout');
    this.layout();
    $$(this.root, '[data-pd-tool]').forEach(function (b) { b.classList.remove('is-active'); });
  };

  P.defaultTextColor = function () {
    return /schwarz|black|navy|dunkel|anthrazit|dark|marine|charcoal/.test(lc(this.selColor)) ? '#ffffff' : '#000000';
  };

  // Wartet auf die Schrift. Ist das Google-Fonts-Stylesheet noch nicht da,
  // liefert fonts.load nichts, dann nach fonts.ready noch einmal versuchen.
  function loadFont(f, weight, style) {
    if (!document.fonts) return Promise.resolve();
    var spec = (style === 'italic' ? 'italic ' : '') + (weight === 'bold' ? '700' : '400') + ' 40px "' + f + '"';
    return document.fonts.load(spec).then(function (list) {
      if (list && list.length) return list;
      return document.fonts.ready.then(function () { return document.fonts.load(spec); });
    }).catch(function () {}).then(function () {
      if (fabric.util.clearFabricFontCache) fabric.util.clearFabricFontCache(f);
    });
  }

  P.addText = function (text, done) {
    var self = this;
    var font = this.lastFont || 'Inter';
    var t = new fabric.IText(text || 'Dein Text', {
      fontFamily: font,
      fontSize: 48,
      fill: this.nextTextColor || this.defaultTextColor(),
      textAlign: 'center',
      originX: 'center',
      originY: 'center',
      pdKind: 'text'
    });
    loadFont(font).then(function () {
      t.initDimensions();
      var s = self.screenArea().w * 0.12 / 48;
      t.set({ scaleX: s, scaleY: s });
      self.centerInArea(t);
      self.fitTextWidth(t);
      self.addObject(t);
      if (done) done(t);
    });
  };

  // Langer Text wird beim Tippen kleiner, damit er im Druckbereich bleibt
  P.fitTextWidth = function (t) {
    var pa = this.printArea();
    var w = t.width * t.scaleX;
    // Quer stehender Text läuft entlang der Höhe des Druckbereichs
    var max = (Math.round((t.angle || 0) / 90) % 2 ? pa.h : pa.w) * 0.92;
    if (w > max) {
      var c = t.getCenterPoint();
      var s = max / t.width;
      t.set({ scaleX: s, scaleY: s });
      t.setPositionByOrigin(c, 'center', 'center');
      t.setCoords();
    }
  };

  P.activeText = function () {
    var o = this.canvas.getActiveObject();
    return o && o.type === 'i-text' ? o : null;
  };

  P.syncTextInput = function (o) {
    var input = $(this.root, '[data-pd-text-input]');
    if (o && input && document.activeElement !== input) input.value = o.text;
  };

  P.onSelect = function () {
    var o = this.canvas.getActiveObject();
    var t = this.activeText();
    this.showArea(!!o);
    var addBtn = $(this.root, '[data-pd-text-add]');
    addBtn.textContent = t ? 'Neuen Text hinzufügen' : 'Text hinzufügen';
    if (t) {
      var fly = $(this.root, '[data-pd-flyout]');
      if (!fly.hidden && fly.dataset.tool === 'text') $(this.root, '[data-pd-text-input]').value = t.text;
    }
    if (!o) this.openPop(null);
    this.syncToolbar();
  };

  // Schwebende Leiste über dem Produkt
  P.syncToolbar = function () {
    var tb = $(this.root, '[data-pd-toolbar]');
    if (!tb) return;
    var o = this.canvas.getActiveObject();
    var stage = $(this.root, '[data-pd-stage]');
    tb.hidden = !o;
    stage.classList.toggle('has-selection', !!o);
    if (!o) return;
    var t = this.activeText();
    var multi = o.type === 'activeSelection';
    var kind = t ? 'text' : (multi ? 'multi' : 'image');
    $$(this.root, '[data-pd-group-only]').forEach(function (el) { el.hidden = multi || !o.pdGroup; });
    $$(this.root, '[data-pd-single-only]').forEach(function (el) { el.hidden = multi; });
    $$(tb, '[data-pd-for]').forEach(function (el) { el.hidden = el.dataset.pdFor !== kind; });
    var sub = o.pdKind === 'motif' && o.type !== 'image' ? 'libmotif' : o.pdKind;
    $$(tb, '[data-pd-only]').forEach(function (el) { el.hidden = el.dataset.pdOnly !== sub; });
    var ms = $(tb, '[data-pd-mcolor-swatch]');
    if (ms) ms.style.background = o.pdColor || '#111111';
    if (t) {
      var fl = $(tb, '[data-pd-font-label]');
      fl.textContent = t.fontFamily;
      fl.style.fontFamily = '"' + t.fontFamily + '"';
      $(tb, '[data-pd-bold]').setAttribute('aria-pressed', t.fontWeight === 'bold' ? 'true' : 'false');
      $(tb, '[data-pd-italic]').setAttribute('aria-pressed', t.fontStyle === 'italic' ? 'true' : 'false');
      $(tb, '[data-pd-underline]').setAttribute('aria-pressed', t.underline ? 'true' : 'false');
      $(tb, '[data-pd-align-cycle]').dataset.align = t.textAlign;
      $(tb, '[data-pd-fill-swatch]').style.background = t.fill;
      $$(this.root, '[data-pd-palette="fill"] [data-c]').forEach(function (b) { b.classList.toggle('is-active', lc(b.dataset.c) === lc(t.fill)); });
      var sc = t.stroke && t.strokeWidth > 0 ? t.stroke : '';
      $$(tb, '[data-pd-palette="stroke"] [data-c]').forEach(function (b) { b.classList.toggle('is-active', lc(b.dataset.c) === lc(sc)); });
      $(tb, '[data-pd-stroke-width]').value = sc ? t.strokeWidth : 0;
      $(tb, '[data-pd-curve]').value = t.pdCurve || 0;
      $$(tb, '[data-pd-font-list] button').forEach(function (b) { b.classList.toggle('is-active', b.dataset.font === t.fontFamily); });
    }
    this.syncSizeRange();
  };

  // Größenregler: 0 bis 100 zwischen kleinster und größter sinnvoller Größe
  P.sizeBounds = function (o) {
    var pa = this.printArea();
    var maxS = Math.min(pa.w / o.width, pa.h / o.height);
    return { min: maxS * 0.06, max: maxS };
  };

  P.syncSizeRange = function () {
    var o = this.canvas.getActiveObject();
    var range = $(this.root, '[data-pd-size-range]');
    if (!o || !range) return;
    var b = this.sizeBounds(o);
    var v = (Math.abs(o.scaleY) - b.min) / (b.max - b.min) * 100;
    range.value = Math.max(0, Math.min(100, Math.round(v)));
  };

  P.setObjSize = function (v) {
    var o = this.canvas.getActiveObject();
    if (!o) return;
    var b = this.sizeBounds(o);
    var s = b.min + (b.max - b.min) * v / 100;
    var c = o.getCenterPoint();
    o.set({ scaleX: s, scaleY: s });
    o.setPositionByOrigin(c, 'center', 'center');
    o.setCoords();
    this.constrain(o);
    this.checkOverlap(true);
    this.canvas.requestRenderAll();
  };

  P.setTextProp = function (props) {
    var t = this.activeText();
    if (!t) return;
    t.set(props);
    if (t.pdCurve) applyCurve(t);
    else { t.initDimensions(); t.setCoords(); }
    this.constrain(t);
    this.canvas.requestRenderAll();
    this.changed({ target: t });
  };

  P.setFont = function (f) {
    var self = this;
    var t = this.activeText();
    this.lastFont = f;
    if (!t) return;
    loadFont(f, t.fontWeight, t.fontStyle).then(function () { self.setTextProp({ fontFamily: f }); });
  };

  P.openPop = function (name) {
    var tb = $(this.root, '[data-pd-toolbar]');
    if (!tb) return;
    var cur = this.openPopName;
    if (name && cur === name) name = null;
    this.openPopName = name;
    $$(tb, '[data-pd-popover]').forEach(function (p) { p.hidden = p.dataset.pdPopover !== name; });
    $$(tb, '[data-pd-pop]').forEach(function (b) { b.setAttribute('aria-expanded', b.dataset.pdPop === name ? 'true' : 'false'); });
  };

  P.renderToolbarLists = function () {
    var self = this;
    var tb = $(this.root, '[data-pd-toolbar]');
    var list = $(tb, '[data-pd-font-list]');
    list.innerHTML = '';
    FONTS.forEach(function (f) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.font = f;
      b.textContent = f;
      b.style.fontFamily = '"' + f + '"';
      b.addEventListener('click', function () { self.setFont(f); self.openPop(null); });
      li.appendChild(b);
      list.appendChild(li);
    });
    var own = (this.root.dataset.textColors || '').split(',').map(function (c) { return lc(c.trim()); }).filter(Boolean);
    var colors = own.length ? own : PALETTE.slice();
    $$(this.root, '[data-pd-palette]').forEach(function (wrap) {
      var kind = wrap.dataset.pdPalette;
      wrap.innerHTML = '';
      var list2 = kind === 'stroke' ? [''].concat(colors) : colors;
      list2.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pd__color' + (c ? '' : ' pd__color--none');
        b.dataset.c = c;
        b.setAttribute('aria-label', c ? 'Farbe ' + c : 'Keine Kontur');
        if (c) b.style.setProperty('--c', c);
        b.addEventListener('click', function () { self.pickColor(kind, c); });
        wrap.appendChild(b);
      });
      var lab = document.createElement('label');
      lab.className = 'pd__color pd__color--custom';
      lab.setAttribute('aria-label', 'Eigene Farbe');
      lab.title = 'Jede Farbe möglich';
      var inp = document.createElement('input');
      inp.type = 'color';
      inp.value = '#2f6fed';
      inp.addEventListener('input', function () { self.pickColor(kind, inp.value); });
      lab.appendChild(inp);
      wrap.appendChild(lab);
    });
  };

  P.pickColor = function (kind, c) {
    if (kind === 'motif') { this.setMotifColor(c); this.syncToolbar(); return; }
    var t = this.activeText();
    if (kind === 'fill') {
      this.nextTextColor = c;
      $$(this.root, '[data-pd-palette="fill"] [data-c]').forEach(function (b) { b.classList.toggle('is-active', lc(b.dataset.c) === lc(c)); });
    }
    if (!t) return;
    if (kind === 'fill') { this.setTextProp({ fill: c }); return; }
    if (!c) { this.setTextProp({ stroke: null, strokeWidth: 0 }); return; }
    var w = t.strokeWidth > 0 && t.stroke ? t.strokeWidth : 3;
    this.setTextProp({ stroke: c, strokeWidth: w, paintFirst: 'stroke', strokeLineJoin: 'round' });
  };

  /* ---------- Vorlagen ---------- */

  P.renderTemplates = function () {
    var self = this;
    var list = $(this.root, '[data-pd-template-list]');
    if (!list) return;
    list.innerHTML = '';
    TEMPLATES.forEach(function (tpl) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pd__tpl';
      b.setAttribute('aria-label', 'Vorlage ' + tpl.name);
      var prev = document.createElement('span');
      prev.className = 'pd__tpl-prev';
      tpl.lines.forEach(function (l) {
        var sp = document.createElement('span');
        sp.textContent = l.text;
        sp.style.fontFamily = '"' + l.font + '"';
        sp.style.fontSize = Math.round(15 * l.size) + 'px';
        if (l.bold) sp.style.fontWeight = '700';
        if (l.spacing) sp.style.letterSpacing = (l.spacing / 1000) + 'em';
        prev.appendChild(sp);
      });
      var name = document.createElement('span');
      name.className = 'pd__tpl-name';
      name.textContent = tpl.name;
      b.appendChild(prev);
      b.appendChild(name);
      b.addEventListener('click', function () { self.addTemplate(tpl); });
      li.appendChild(b);
      list.appendChild(li);
    });
  };

  P.addTemplate = function (tpl) {
    var self = this;
    var color = this.defaultTextColor();
    Promise.all(tpl.lines.map(function (l) { return loadFont(l.font, l.bold ? 'bold' : 'normal'); })).then(function () {
      var pa = self.screenArea();
      var base = pa.w * 0.11;
      var objs = tpl.lines.map(function (l) {
        var t = new fabric.IText(l.text, {
          fontFamily: l.font, fontSize: 48, fontWeight: l.bold ? 'bold' : 'normal',
          charSpacing: l.spacing || 0, fill: color, textAlign: 'center',
          originX: 'center', originY: 'center', pdKind: 'text', pdCurve: l.curve || 0
        });
        applyCurve(t);
        var s = base * l.size / 48;
        t.set({ scaleX: s, scaleY: s });
        return t;
      });
      var widest = Math.max.apply(null, objs.map(function (o) { return o.width * o.scaleX; }));
      var k = Math.min(1, pa.w * 0.85 / widest);
      var gap = base * 0.12 * k;
      var total = -gap;
      objs.forEach(function (o) { o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k }); total += o.height * o.scaleY + gap; });
      var y = pa.cy - pa.h / 2 + Math.max(pa.h * 0.08, (pa.h * 0.55 - total) / 2);
      // Immer nur eine Vorlage: eine vorhandene wird ersetzt, auch auf den anderen Seiten
      var gid = 'tpl' + Date.now().toString(36);
      var replaced = false;
      self.batch = true;
      self.canvas.discardActiveObject();
      self.canvas.getObjects().slice().forEach(function (o) {
        if (o.pdGroup) { self.canvas.remove(o); replaced = true; }
      });
      self.views.forEach(function (v) {
        if (v === self.view() || !self.designs[v.name]) return;
        var before = self.designs[v.name].length;
        self.designs[v.name] = self.designs[v.name].filter(function (j) { return !j.pdGroup; });
        if (self.designs[v.name].length !== before) { replaced = true; delete self.history[v.name]; }
      });
      objs.forEach(function (o) {
        var h = o.height * o.scaleY;
        o.set({ left: pa.cx, top: y + h / 2 });
        o.setCoords();
        y += h + gap;
        o.pdGroup = gid;
      });
      self.turnUpright(objs);
      objs.forEach(function (o) {
        self.styleObject(o);
        self.canvas.add(o);
      });
      self.batch = false;
      self.constrain(objs[0]);
      if (replaced) self.notice('Es ist immer nur eine Vorlage möglich. Die vorherige wurde ersetzt.', true);
      self.canvas.setActiveObject(objs[0]);
      self.canvas.requestRenderAll();
      self.changed();
      self.onSelect();
      if (window.matchMedia('(max-width: 899px)').matches) self.closeTool();
    });
  };

  /* ---------- Upload ---------- */

  P.handleFiles = function (files) {
    var self = this;
    var err = $(this.root, '[data-pd-upload-error]');
    err.hidden = true;
    Array.prototype.forEach.call(files, function (file, i) {
      var isSvg = file.type === 'image/svg+xml' || /\.svg$/i.test(file.name);
      var isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
      var ok = isSvg || isPdf || /^image\/(png|jpeg)$/.test(file.type);
      if (!ok) { err.textContent = file.name + ': Nur PNG, JPG, SVG oder PDF.'; err.hidden = false; return; }
      if (file.size > self.maxUploadMb * 1024 * 1024) {
        err.textContent = file.name + ': Die Datei ist größer als ' + self.maxUploadMb + ' MB.'; err.hidden = false; return;
      }
      if (isPdf) {
        self.notice('PDF wird geladen …', true);
        pdfToPng(file).then(function (data) {
          var n = $(self.root, '[data-pd-notice]'); if (n) n.hidden = true;
          var item = { name: file.name, svg: false, data: data, orig: file };
          self.uploads.unshift(item);
          self.renderUploads();
          if (i === 0) self.addUpload(item);
        }, function (e) {
          var n = $(self.root, '[data-pd-notice]'); if (n) n.hidden = true;
          console.warn('PDF', e);
          err.textContent = file.name + ': Die PDF-Datei konnte nicht gelesen werden. Bitte als PNG, JPG oder SVG hochladen.'; err.hidden = false;
        });
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        var item = { name: file.name, svg: isSvg, data: reader.result };
        self.uploads.unshift(item);
        self.renderUploads();
        if (i === 0) self.addUpload(item);
      };
      if (isSvg) reader.readAsText(file); else reader.readAsDataURL(file);
    });
  };

  P.renderUploads = function () {
    var list = $(this.root, '[data-pd-upload-list]');
    var self = this;
    list.innerHTML = '';
    this.uploads.forEach(function (u) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.title = u.name;
      var img = document.createElement('img');
      img.alt = u.name;
      img.src = u.svg ? 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(u.data) : u.data;
      b.appendChild(img);
      b.addEventListener('click', function () { self.addUpload(u); });
      li.appendChild(b);
      list.appendChild(li);
    });
  };

  P.addUpload = function (u) {
    var self = this;
    if (u.svg) {
      fabric.loadSVGFromString(u.data, function (objs, opts) {
        if (!objs || !objs.length) { self.notice('Die SVG-Datei konnte nicht gelesen werden.'); return; }
        var g = fabric.util.groupSVGElements(objs, opts);
        g.set({ pdKind: 'svg', pdName: u.name });
        self.fitObject(g, 0.7);
        self.addObject(g);
      });
      return;
    }
    fabric.Image.fromURL(u.data, function (img) {
      if (!img || !img.width) { self.notice('Das Bild konnte nicht gelesen werden.'); return; }
      img.set({ pdKind: 'image', pdNatW: img.width, pdName: u.name });
      self.fitObject(img, 0.7);
      self.addObject(img);
      self.offerBgRemoval(img);
    });
  };

  // Originaldateien (PDF) der Bilder, die im Design wirklich vorkommen
  P.uploadOriginals = function () {
    var self = this, names = {};
    function add(o) {
      if (!o) return;
      if (o.pdName) names[o.pdName] = 1;
      (o._objects || o.objects || []).forEach(add);
    }
    if (this.canvas) this.canvas.getObjects().forEach(add);
    this.views.forEach(function (v) { if (v !== self.view()) (self.designs[v.name] || []).forEach(add); });
    var out = [];
    this.uploads.forEach(function (u) { if (u.orig && names[u.name] && out.indexOf(u.orig) === -1) out.push(u.orig); });
    return out;
  };

  P.addMotif = function (url, natW) {
    var self = this;
    fabric.Image.fromURL(url, function (img) {
      if (!img || !img.width) { self.notice('Das Bild konnte nicht geladen werden.'); return; }
      img.set({ pdKind: 'motif', pdNatW: natW ? Math.min(natW, img.width) : img.width });
      self.fitObject(img, 0.6);
      self.addObject(img);
    }, { crossOrigin: 'anonymous' });
  };

  /* ---------- Hinweise und Dialoge ---------- */

  P.notice = function (text, info) {
    var n = $(this.root, '[data-pd-notice]');
    n.textContent = text;
    n.classList.toggle('is-info', !!info);
    n.hidden = false;
    clearTimeout(this.noticeTimer);
    this.noticeTimer = setTimeout(function () { n.hidden = true; }, 4500);
  };

  P.openModal = function (name) {
    var m = $(this.root, '[data-pd-modal="' + name + '"]');
    if (!m) return;
    if (m.parentNode !== document.body) document.body.appendChild(m);
    m.hidden = false;
    var self = this;
    if (!m.dataset.bound) {
      m.dataset.bound = '1';
      m.addEventListener('click', function (e) {
        if (e.target === m || e.target.closest('[data-pd-close]')) self.closeModal(m);
      });
    }
    this.openModalEl = m;
  };

  P.closeModal = function (m) {
    m = m || this.openModalEl;
    if (m) m.hidden = true;
    this.openModalEl = null;
  };

  P.updateDelivery = function () {
    var el = $(this.root, '[data-pd-delivery]');
    if (!el) return;
    function addWorkdays(d, n) {
      d = new Date(d.getTime());
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    var fmt = { weekday: 'short', day: 'numeric', month: 'short' };
    var now = new Date();
    var from = addWorkdays(now, parseInt(el.dataset.min, 10) || 5).toLocaleDateString('de-DE', fmt);
    var to = addWorkdays(now, parseInt(el.dataset.max, 10) || 7).toLocaleDateString('de-DE', fmt);
    el.textContent = (el.dataset.template || '')
      .replace('[datum]', to).replace('[bis]', to).replace('[von]', from);
  };

  /* ---------- Export ---------- */

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      try {
        canvas.toBlob(function (b) { b ? resolve(b) : reject(new Error('blob')); }, type, quality);
      } catch (e) { reject(e); }
    });
  }

  function loadInto(sc, objects) {
    return new Promise(function (resolve) {
      sc.loadFromJSON({ objects: objects }, function () { fixCurves(sc.getObjects()); sc.renderAll(); resolve(); });
    });
  }

  P.renderPrint = function (view, dpi) {
    var pa = this.printArea(view);
    var wPx = Math.round(view.cm_w / 2.54 * dpi);
    var scale = wPx / pa.w;
    var hPx = Math.round(pa.h * scale);
    var sc = new fabric.StaticCanvas(null, { width: wPx, height: hPx, enableRetinaScaling: false });
    sc.setViewportTransform([scale, 0, 0, scale, -pa.x * scale, -pa.y * scale]);
    return loadInto(sc, this.designs[view.name] || []).then(function () {
      return canvasToBlob(sc.getElement(), 'image/png');
    }).then(function (blob) {
      sc.dispose();
      return { blob: blob, dpi: dpi, w: wPx, h: hPx };
    });
  };

  P.renderPrintSized = function (view) {
    var self = this;
    var steps = [this.dpi, 200, 150].filter(function (d, i, a) { return d <= self.dpi && a.indexOf(d) === i; });
    function attempt(i) {
      return self.renderPrint(view, steps[i]).then(function (r) {
        if (r.blob.size > MAX_FILE_BYTES && i < steps.length - 1) return attempt(i + 1);
        return r;
      });
    }
    return attempt(0);
  };

  /* Vektordatei (SVG) für die Produktion. Texte werden zu Pfaden, damit
     die Druckerei keine Schriften braucht. Hochgeladene SVGs und Motive
     bleiben Vektoren. Hochgeladene Bilder (JPG/PNG) bleiben
     unverändert als Bild drin. */
  var OT_URL = 'https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.min.js';
  var FONT_CDN = 'https://cdn.jsdelivr.net/npm/@fontsource/';
  var otPromise = null, otFonts = {};

  function loadOpentype() {
    if (window.opentype) return Promise.resolve(window.opentype);
    if (!otPromise) {
      otPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = OT_URL;
        s.onload = function () { window.opentype ? resolve(window.opentype) : reject(new Error('opentype')); };
        s.onerror = function () { otPromise = null; reject(new Error('opentype')); };
        document.head.appendChild(s);
      });
    }
    return otPromise;
  }

  function fontFileUrl(family, weight, style) {
    var id = lc(family).replace(/[^a-z0-9]+/g, '-');
    return FONT_CDN + id + '@5/files/' + id + '-latin-' + weight + '-' + style + '.woff';
  }

  function vecFont(family, weight, style) {
    var w = (weight === 'bold' || +weight >= 600) ? 700 : 400;
    var st = style === 'italic' ? 'italic' : 'normal';
    var key = family + '|' + w + '|' + st;
    if (otFonts[key]) return otFonts[key];
    // Gibt es den Schnitt nicht (z. B. Anton fett), nehmen wir den normalen
    var tries = [[w, st], [w, 'normal'], [400, st], [400, 'normal']].filter(function (t, i, a) {
      return a.findIndex(function (u) { return u[0] === t[0] && u[1] === t[1]; }) === i;
    });
    otFonts[key] = loadOpentype().then(function (ot) {
      function next(i) {
        if (i >= tries.length) return Promise.reject(new Error('Schrift ' + family));
        return fetch(fontFileUrl(family, tries[i][0], tries[i][1])).then(function (r) {
          if (!r.ok) throw new Error('http');
          return r.arrayBuffer();
        }).then(function (buf) { return ot.parse(buf); }).catch(function () { return next(i + 1); });
      }
      return next(0);
    });
    otFonts[key].catch(function () { delete otFonts[key]; });
    return otFonts[key];
  }

  function svgNum(n) { return String(Math.round(n * 1000) / 1000); }
  function svgAttr(v) { return String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  // Zeichnet den Text einmal auf ein Hilfs-Canvas und merkt sich jeden
  // fillText/strokeText-Aufruf mit Position. So landen Bogen, Abstand und
  // Ausrichtung genau so in der Datei, wie der Kunde sie gesehen hat.
  function recordText(o) {
    var el = document.createElement('canvas');
    el.width = el.height = 2;
    var ctx = el.getContext('2d');
    var calls = [];
    ['fillText', 'strokeText'].forEach(function (m) {
      var orig = ctx[m];
      ctx[m] = function (text, x, y) {
        calls.push({
          stroke: m === 'strokeText', text: String(text), x: x, y: y, m: ctx.getTransform(),
          fill: ctx.fillStyle, strokeStyle: ctx.strokeStyle, lineWidth: ctx.lineWidth,
          lineJoin: ctx.lineJoin, miter: ctx.miterLimit, font: ctx.font, alpha: ctx.globalAlpha
        });
        return orig.apply(ctx, arguments);
      };
    });
    var cache = o.objectCaching;
    o.objectCaching = false;
    o.render(ctx);
    o.objectCaching = cache;
    return calls;
  }

  function textToSvg(o) {
    var calls = recordText(o);
    return vecFont(o.fontFamily, o.fontWeight, o.fontStyle).then(function (font) {
      var out = [];
      calls.forEach(function (c) {
        if (!c.text.trim()) return;
        var px = parseFloat((/([\d.]+)px/.exec(c.font) || [])[1]) || o.fontSize;
        var d = font.getPath(c.text, c.x, c.y, px, { kerning: true }).toPathData(3);
        if (!d) return;
        var m = c.m;
        var a = ' transform="matrix(' + [m.a, m.b, m.c, m.d, m.e, m.f].map(svgNum).join(' ') + ')"';
        if (c.alpha < 1) a += ' opacity="' + svgNum(c.alpha) + '"';
        if (c.stroke) {
          out.push('<path d="' + d + '"' + a + ' fill="none" stroke="' + svgAttr(c.strokeStyle) + '" stroke-width="' + svgNum(c.lineWidth) +
            '" stroke-linejoin="' + c.lineJoin + '" stroke-miterlimit="' + svgNum(c.miter) + '"/>');
        } else {
          out.push('<path d="' + d + '"' + a + ' fill="' + svgAttr(c.fill) + '"/>');
        }
      });
      return '<g id="' + svgAttr(o.pdName || ('Text ' + o.text).slice(0, 40)) + '">\n' + out.join('\n') + '\n</g>\n';
    });
  }

  var PDFJS_URL = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js';
  var PDFJS_WORKER = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
  var pdfPromise = null;

  function loadPdfJs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (!pdfPromise) {
      pdfPromise = new Promise(function (resolve, reject) {
        var amd = window.define;
        if (typeof amd === 'function' && amd.amd) window.define = undefined;
        var s = document.createElement('script');
        s.src = PDFJS_URL;
        s.onload = function () {
          window.define = amd;
          var lib = window.pdfjsLib;
          if (!lib) { pdfPromise = null; reject(new Error('pdfjs')); return; }
          lib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
          resolve(lib);
        };
        s.onerror = function () { window.define = amd; pdfPromise = null; reject(new Error('pdfjs')); };
        document.head.appendChild(s);
      });
    }
    return pdfPromise;
  }

  // Erste Seite einer PDF als PNG mit durchsichtigem Hintergrund, lange Seite ca. 3000 px
  function pdfToPng(file) {
    return Promise.all([loadPdfJs(), file.arrayBuffer()]).then(function (r) {
      return r[0].getDocument({ data: new Uint8Array(r[1]) }).promise;
    }).then(function (doc) {
      return doc.getPage(1).then(function (page) {
        var v1 = page.getViewport({ scale: 1 });
        var scale = Math.min(3000 / Math.max(v1.width, v1.height), Math.sqrt(12e6 / (v1.width * v1.height)));
        var vp = page.getViewport({ scale: scale });
        var cv = document.createElement('canvas');
        cv.width = Math.round(vp.width); cv.height = Math.round(vp.height);
        return page.render({ canvasContext: cv.getContext('2d'), viewport: vp, background: 'rgba(0,0,0,0)' }).promise.then(function () {
          var url = cv.toDataURL('image/png');
          doc.destroy();
          return url;
        });
      });
    });
  }

  var IT_URL = 'https://cdn.jsdelivr.net/npm/imagetracerjs@1.2.6/imagetracer_v1.2.6.js';
  var itPromise = null;

  function loadTracer() {
    if (window.ImageTracer) return Promise.resolve(window.ImageTracer);
    if (!itPromise) {
      itPromise = new Promise(function (resolve, reject) {
        // Seiten mit AMD-Loader würden die Bibliothek sonst nicht global anlegen
        var amd = window.define;
        if (typeof amd === 'function' && amd.amd) window.define = undefined;
        var s = document.createElement('script');
        s.src = IT_URL;
        s.onload = function () { window.define = amd; window.ImageTracer ? resolve(window.ImageTracer) : reject(new Error('tracer')); };
        s.onerror = function () { window.define = amd; itPromise = null; reject(new Error('tracer')); };
        document.head.appendChild(s);
      });
    }
    return itPromise;
  }

  // Hauptfarben eines Bildes. Ein Logo hat wenige Flächenfarben, ein Foto
  // verteilt sich auf sehr viele. Liefert null, wenn es ein Foto ist.
  function logoPalette(data, minShare) {
    minShare = minShare || 0.004;
    var bins = {}, opaque = 0, i, k;
    for (i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 128) continue;
      opaque++;
      k = (data[i] >> 4) * 256 + (data[i + 1] >> 4) * 16 + (data[i + 2] >> 4);
      var b = bins[k] || (bins[k] = { n: 0, r: 0, g: 0, b: 0 });
      b.n++; b.r += data[i]; b.g += data[i + 1]; b.b += data[i + 2];
    }
    if (!opaque) return null;
    var list = Object.keys(bins).map(function (key) { return bins[key]; }).sort(function (a, b) { return b.n - a.n; });
    var top = list.slice(0, 12), covered = top.reduce(function (s, b) { return s + b.n; }, 0);
    if (covered / opaque < 0.85) return null;
    // ähnliche Töne (z. B. Schwarz und Fast-Schwarz) zu einer Farbe zusammenfassen
    var groups = [];
    top.forEach(function (b) {
      var c = [b.r / b.n, b.g / b.n, b.b / b.n];
      var hit = groups.find(function (g) {
        return Math.abs(g.r / g.n - c[0]) + Math.abs(g.g / g.n - c[1]) + Math.abs(g.b / g.n - c[2]) < 60;
      });
      if (hit) { hit.n += b.n; hit.r += b.r; hit.g += b.g; hit.b += b.b; }
      else groups.push({ n: b.n, r: b.r, g: b.g, b: b.b });
    });
    groups.sort(function (a, b) { return b.n - a.n; });
    var pal = [{ r: 0, g: 0, b: 0, a: 0 }];
    groups.forEach(function (b) {
      if (b.n / opaque >= minShare || pal.length < 2) pal.push({ r: Math.round(b.r / b.n), g: Math.round(b.g / b.n), b: Math.round(b.b / b.n), a: 255 });
    });
    return pal;
  }

  // Zeichnet ein Bildobjekt als Vektorpfade nach. Ergebnis ersetzt das
  // <image> in der SVG, Lage und Größe bleiben gleich.
  function traceImage(o) {
    var el = o._element;
    var W = el && (el.naturalWidth || el.width), H = el && (el.naturalHeight || el.height);
    if (!W || !H) return Promise.resolve('Bild nicht lesbar');
    var f = Math.min(1, 1200 / Math.max(W, H));
    var tw = Math.max(1, Math.round(W * f)), th = Math.max(1, Math.round(H * f));
    var c = document.createElement('canvas');
    c.width = tw; c.height = th;
    var ctx = c.getContext('2d');
    ctx.drawImage(el, 0, 0, tw, th);
    var imgd;
    try { imgd = ctx.getImageData(0, 0, tw, th); } catch (e) { return Promise.resolve('Bild nicht lesbar'); }
    var d = imgd.data;
    // Halbtransparente Kanten klar trennen, sonst entstehen Schleier-Flächen
    for (var i = 3; i < d.length; i += 4) d[i] = d[i] < 128 ? 0 : 255;
    var pal = logoPalette(d);
    if (!pal) return Promise.resolve('Foto, bleibt als Bild in der Datei');
    return loadTracer().then(function (IT) {
      var opts = { pal: pal, colorquantcycles: 2, mincolorratio: 0, ltres: 1, qtres: 1, pathomit: 8,
        rightangleenhance: true, strokewidth: 0.5, roundcoords: 2, blurradius: 0 };
      var td = IT.imagedataToTracedata(imgd, opts);
      var paths = [];
      td.layers.forEach(function (layer, ln) {
        var col = td.palette[ln];
        if (!col || col.a < 128) return;
        col.a = 255;
        layer.forEach(function (p, pn) {
          // dünne Kontur in Flächenfarbe schließt Haarlinien zwischen den Farben
          if (!p.isholepath) paths.push(IT.svgpathstring(td, ln, pn, opts));
        });
      });
      if (!paths.length) return 'Bild leer';
      var x = -o.width / 2 - (o.cropX || 0), y = -o.height / 2 - (o.cropY || 0);
      // fabric ersetzt das Array-Element 'COMMON_PARTS' durch Stil und Deckkraft
      var tail = ' transform="translate(' + svgNum(x) + ' ' + svgNum(y) + ') scale(' + svgNum(W / tw) + ' ' + svgNum(H / th) + ')">\n' +
        paths.join('\n') + '\n</g>\n';
      o._toSVG = function () { return ['<g ', 'COMMON_PARTS', tail]; };
      return '';
    }, function () { return 'Nachzeichnen nicht geladen, bleibt als Bild'; });
  }

  P.renderVector = function (view) {
    var pa = this.printArea(view);
    var sc = new fabric.StaticCanvas(null, { width: Math.ceil(pa.x + pa.w), height: Math.ceil(pa.y + pa.h), enableRetinaScaling: false });
    var missing = [], traced = [];
    return loadInto(sc, this.designs[view.name] || []).then(function () {
      var texts = sc.getObjects().filter(function (o) { return o.type === 'i-text' || o.type === 'text' || o.type === 'textbox'; });
      return Promise.all(texts.map(function (o) {
        return textToSvg(o).then(function (svg) {
          o.toSVG = function () { return svg; };
        }, function () {
          // Schrift nicht ladbar: Text bleibt als Text mit Schriftname in der Datei
          missing.push('Schrift nicht umgewandelt: ' + o.fontFamily);
        });
      }));
    }).then(function () {
      // Hochgeladene Bilder bleiben unverändert als Bild in der Datei
      // (automatisches Nachzeichnen war Borsa und dem Kunden zu ungenau)
      var svg = sc.toSVG({
        width: svgNum(view.cm_w) + 'cm',
        height: svgNum(view.cm_h) + 'cm',
        viewBox: { x: pa.x, y: pa.y, width: pa.w, height: pa.h },
        suppressPreamble: false
      });
      sc.dispose();
      return { blob: new Blob([svg], { type: 'image/svg+xml' }), missing: missing, traced: traced };
    });
  };

  P.clipFor = function (view) {
    var pa = this.printArea(view);
    return new fabric.Rect({ left: pa.x, top: pa.y, width: pa.w, height: pa.h, absolutePositioned: true });
  };

  P.renderPreview = function (view) {
    var self = this;
    var m = this.imageFor(view, this.selColor);
    var W = 900;
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = m ? m.src : '';
    }).then(function (img) {
      var ratio = img && img.naturalWidth ? img.naturalWidth / img.naturalHeight : self.ratioFor(view);
      var H = Math.round(W / ratio);
      var out = document.createElement('canvas');
      out.width = W; out.height = H;
      var ctx = out.getContext('2d');
      ctx.fillStyle = '#f4f4f4';
      ctx.fillRect(0, 0, W, H);
      if (img) {
        ctx.globalCompositeOperation = 'multiply';
        ctx.drawImage(img, 0, 0, W, H);
        ctx.globalCompositeOperation = 'source-over';
      }
      var sc = new fabric.StaticCanvas(null, { width: W, height: H, enableRetinaScaling: false });
      sc.setZoom(W / LOGICAL_W);
      sc.clipPath = self.clipFor(view);
      return loadInto(sc, self.designs[view.name] || []).then(function () {
        ctx.drawImage(sc.getElement(), 0, 0);
        sc.dispose();
        return canvasToBlob(out, 'image/jpeg', 0.85).catch(function () {
          // Produktbild ohne CORS: nur das Motiv als Vorschau
          var o2 = document.createElement('canvas');
          o2.width = W; o2.height = H;
          var c2 = o2.getContext('2d');
          c2.fillStyle = '#f4f4f4'; c2.fillRect(0, 0, W, H);
          var sc2 = new fabric.StaticCanvas(null, { width: W, height: H, enableRetinaScaling: false });
          sc2.setZoom(W / LOGICAL_W);
          sc2.clipPath = self.clipFor(view);
          return loadInto(sc2, self.designs[view.name] || []).then(function () {
            c2.drawImage(sc2.getElement(), 0, 0);
            sc2.dispose();
            return canvasToBlob(o2, 'image/jpeg', 0.85);
          });
        });
      });
    });
  };

  // Größe und Lage des Motivs im Druckbereich in cm
  P.motifInfo = function (view) {
    var pa = this.printArea(view);
    var objs = this.designs[view.name] || [];
    var sc = new fabric.StaticCanvas(null, { width: 10, height: 10 });
    return loadInto(sc, objs).then(function () {
      var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      sc.getObjects().forEach(function (o) {
        var r = o.getBoundingRect(true, true);
        minX = Math.min(minX, r.left); minY = Math.min(minY, r.top);
        maxX = Math.max(maxX, r.left + r.width); maxY = Math.max(maxY, r.top + r.height);
      });
      sc.dispose();
      minX = Math.max(minX, pa.x); minY = Math.max(minY, pa.y);
      maxX = Math.min(maxX, pa.x + pa.w); maxY = Math.min(maxY, pa.y + pa.h);
      var cmPer = view.cm_w / pa.w;
      return round1((maxX - minX) * cmPer) + ' × ' + round1((maxY - minY) * cmPer) + ' cm, ' +
        round1((minY - pa.y) * cmPer) + ' cm von oben, ' + round1((minX - pa.x) * cmPer) + ' cm von links';
    });
  };

  /* ---------- Warenkorb ---------- */

  P.formError = function (text) {
    var e = $(this.root, '[data-pd-form-error]');
    e.textContent = text || '';
    e.hidden = !text;
  };

  P.submit = function (ev) {
    ev.preventDefault();
    var self = this;
    this.formError('');
    var lines = this.sizeLines();
    if (!lines.length) {
      $(this.root, '[data-pd-size-error]').hidden = false;
      var grid = $(this.root, '[data-pd-size-grid]');
      grid.classList.add('is-error');
      grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    for (var i = 0; i < lines.length; i++) {
      if (!lines[i].variant || !lines[i].variant.available) { this.formError('Diese Variante ist leider ausverkauft.'); return; }
    }
    this.saveView();
    if (this.hasUploads()) {
      var cb = $(this.root, '[data-pd-rights-input]');
      if (cb && !cb.checked) {
        $(this.root, '[data-pd-rights-error]').hidden = false;
        $(this.root, '[data-pd-rights]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    var printed = this.views.filter(function (v) { return (self.designs[v.name] || []).length > 0; });
    Promise.all(printed.map(function (v) { return self.viewHasOverlap(v); })).then(function (res) {
      var bad = printed.filter(function (v, i) { return res[i]; });
      if (bad.length) {
        self.formError('Auf ' + bad.map(function (v) { return v.name; }).join(', ') + ' überlappen sich Motive. Bitte schiebe sie auseinander, so können wir nicht drucken.');
        if (bad.indexOf(self.view()) === -1) self.showView(self.views.indexOf(bad[0]));
        return;
      }
      // Eigenes Bild ohne Datei-Check: einmal nachfragen, bevor es in den Warenkorb geht
      if (self.hasUploads() && !self.service && !self.fileCheckAsked) {
        self.pendingCart = { lines: lines, printed: printed };
        self.openModal('filecheck');
        return;
      }
      self.flyToCart();
      self.sendToCart(lines, printed);
    });
  };

  P.answerFileCheck = function (choice) {
    this.fileCheckAsked = true;
    if (choice) this.setService(choice);
    this.closeModal();
    var p = this.pendingCart;
    this.pendingCart = null;
    if (!p) return;
    this.flyToCart();
    this.sendToCart(p.lines, p.printed);
  };

  // Motiv fliegt sofort beim Klick sichtbar zum Warenkorb-Symbol
  P.flyToCart = function () {
    try {
      var mock = $(this.root, '[data-pd-mockup]');
      var icon = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
      if (!mock || !icon) return;
      var r = mock.getBoundingClientRect(), t = icon.getBoundingClientRect();
      if (!r.width || !t.width) return;
      var fly = document.createElement('div');
      fly.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;overflow:hidden;border-radius:12px;background:#f4f4f4;' +
        'box-shadow:0 12px 40px rgba(0,0,0,.25);left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;' +
        'transform-origin:center;transition:transform .8s cubic-bezier(.5,-0.2,.7,1),opacity .8s ease-in,border-radius .8s;';
      var base = $(mock, '[data-pd-mockup-img]');
      if (base) {
        var bi = document.createElement('img');
        bi.src = base.currentSrc || base.src;
        bi.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;';
        fly.appendChild(bi);
      }
      if (this.canvas && this.canvas.lowerCanvasEl) {
        var cv = this.canvas.lowerCanvasEl, cr = cv.getBoundingClientRect();
        var ci = document.createElement('img');
        ci.src = cv.toDataURL('image/png');
        ci.style.cssText = 'position:absolute;left:' + (cr.left - r.left) + 'px;top:' + (cr.top - r.top) + 'px;width:' + cr.width + 'px;height:' + cr.height + 'px;';
        fly.appendChild(ci);
      }
      document.body.appendChild(fly);
      var dx = (t.left + t.width / 2) - (r.left + r.width / 2);
      var dy = (t.top + t.height / 2) - (r.top + r.height / 2);
      var s = Math.max(0.04, 40 / Math.max(r.width, r.height));
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')';
          fly.style.opacity = '0.3';
          fly.style.borderRadius = '50%';
        });
      });
      setTimeout(function () {
        fly.remove();
        if (icon.animate) icon.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'ease-out' });
      }, 820);
    } catch (e) { console.warn('Animation', e); }
  };

  // Nach dem Hinzufügen: Hinweis unten, Mengen leeren, Design bleibt für die nächste Farbe
  P.addedToast = function (lines, drawer) {
    var self = this;
    var old = document.querySelector('.pd-toast');
    if (old) old.remove();
    var pieces = lines.reduce(function (s, l) { return s + (l.qty || 1); }, 0);
    var what = pieces + ' Stück' + (this.selColor ? ' in ' + this.selColor : '') +
      (lines.length > 1 || lines[0].size ? ' (' + lines.map(function (l) { return l.size ? l.size + ' ' + l.qty : l.qty; }).join(', ') + ')' : '');
    var box = document.createElement('div');
    box.className = 'pd-toast';
    box.setAttribute('role', 'status');
    box.style.cssText = 'position:fixed;left:50%;bottom:20px;z-index:9998;transform:translate(-50%,20px);opacity:0;transition:transform .3s,opacity .3s;' +
      'background:#111;color:#fff;border-radius:12px;padding:14px 16px;max-width:min(92vw,520px);width:max-content;box-shadow:0 10px 30px rgba(0,0,0,.3);' +
      'display:flex;gap:12px;align-items:center;flex-wrap:wrap;font-size:14px;line-height:1.35;';
    var txt = document.createElement('div');
    txt.style.cssText = 'flex:1 1 220px;';
    var b = document.createElement('strong');
    b.textContent = '✓ ' + what + ' liegt im Warenkorb.';
    txt.appendChild(b);
    txt.appendChild(document.createElement('br'));
    txt.appendChild(document.createTextNode('Dein Design bleibt. Wähle einfach die nächste Farbe und lege sie dazu.'));
    var go = document.createElement('button');
    go.type = 'button';
    go.textContent = 'Zum Warenkorb';
    go.style.cssText = 'background:#fff;color:#111;border:0;border-radius:8px;padding:10px 14px;font-weight:600;cursor:pointer;';
    go.addEventListener('click', function () {
      box.remove();
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    });
    var x = document.createElement('button');
    x.type = 'button';
    x.setAttribute('aria-label', 'Schließen');
    x.textContent = '×';
    x.style.cssText = 'background:none;border:0;color:#fff;font-size:22px;line-height:1;cursor:pointer;padding:0 4px;';
    x.addEventListener('click', function () { box.remove(); });
    box.appendChild(txt); box.appendChild(go); box.appendChild(x);
    document.body.appendChild(box);
    requestAnimationFrame(function () { box.style.transform = 'translate(-50%,0)'; box.style.opacity = '1'; });
    setTimeout(function () { if (box.isConnected) { box.style.opacity = '0'; setTimeout(function () { box.remove(); }, 300); } }, 9000);
    // Mengen auf 0, damit die nächste Farbe frisch gezählt wird
    if (this.sizeQty) {
      Object.keys(this.sizeQty).forEach(function (k) { self.sizeQty[k] = 0; });
      $$(this.root, '.pd__size-cell input').forEach(function (i) { if (!i.disabled) i.value = 0; });
      this.syncQty();
    }
  };

  P.sendToCart = function (lines, printed) {
    var self = this;
    var base = new FormData(this.form);
    base.delete('id');
    base.delete('quantity');
    var designId = 'D' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase();
    var busy = $(this.root, '[data-pd-busy]');
    var btn = $(this.root, '[data-pd-add]');
    btn.disabled = true;
    busy.hidden = false;
    var firstPreview = null;
    var props = [];
    var vectorProps = [];

    // Druckdateien nur einmal erzeugen, dann an jede Größe hängen
    var chain = Promise.resolve();
    if (printed.length) {
      props.push(['properties[Druckseiten]', printed.map(function (v) { return v.name; }).join(', ')]);
      props.push(['properties[_Design-ID]', designId]);
    }
    if (this.hasUploads()) {
      props.push(['properties[_Rechte bestätigt]', 'Ja']);
      props.push(['properties[Datei-Check]', this.service === 'rework' ? 'Logo-Überarbeitung gebucht (Vorlage zur Freigabe vor dem Druck)' : this.service === 'check' ? 'Ja, Datei wird vor dem Druck geprüft' : 'Nein, Druck wie hochgeladen']);
      this.uploadOriginals().forEach(function (f, i) { props.push(['properties[_Originaldatei ' + (i + 1) + ']', f]); });
    }
    var service = this.serviceActive();
    var serviceVariant = service === 'rework' ? this.reworkVariant : service === 'check' ? this.fileCheckVariant : '';
    var motifs = this.motifCount(), extra = Math.max(0, motifs - 1);
    if (motifs) props.push(['properties[Motive]', String(motifs) + (extra ? ' (1 inklusive, ' + extra + ' mit Aufpreis)' : ' (inklusive)')]);
    var pieces = lines.reduce(function (s, l) { return s + (l.qty || 1); }, 0);
    printed.forEach(function (view) {
      var slug = lc(view.name).replace(/[^a-z0-9]+/g, '-');
      chain = chain.then(function () {
        return self.renderPrintSized(view).then(function (r) {
          props.push(['properties[_Druckdatei ' + view.name + ']', new File([r.blob], designId + '-' + slug + '.png', { type: 'image/png' })]);
          props.push(['properties[_Druckformat ' + view.name + ']', r.w + ' × ' + r.h + ' px, ' + r.dpi + ' dpi, Druckbereich ' + round1(view.cm_w) + ' × ' + round1(view.cm_h) + ' cm']);
          // Vektordatei zusätzlich; klappt sie nicht, geht die Bestellung trotzdem
          return self.renderVector(view).then(function (v) {
            var f = new File([v.blob], designId + '-' + slug + '.svg', { type: 'image/svg+xml' });
            props.push(['properties[_Vektordatei ' + view.name + ']', f]);
            vectorProps.push('properties[_Vektordatei ' + view.name + ']');
            var notes = v.missing.slice();
            if (v.traced.length) notes.push('Automatisch vektorisiert: ' + v.traced.join(', '));
            if (notes.length) props.push(['properties[_Vektor Hinweis ' + view.name + ']', notes.join('; ')]);
          }, function (e) { console.warn('Vektordatei', e); });
        }).then(function () {
          return self.motifInfo(view);
        }).then(function (info) {
          props.push(['properties[_Motiv ' + view.name + ']', info]);
          return self.renderPreview(view);
        }).then(function (blob) {
          if (!firstPreview) firstPreview = blob;
          props.push(['properties[Vorschau ' + view.name + ']', new File([blob], designId + '-' + slug + '-vorschau.jpg', { type: 'image/jpeg' })]);
        });
      });
    });

    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && typeof drawer.renderContents === 'function';
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var last = null, added = [];
    lines.forEach(function (line, i) {
      chain = chain.then(function () {
        var fd = new FormData();
        base.forEach(function (val, key) { fd.append(key, val); });
        fd.set('id', line.variant.id);
        fd.set('quantity', String(line.qty || parseInt(base.get('quantity'), 10) || 1));
        if (lines.length > 1) fd.append('properties[_Bestellung]', designId);
        props.forEach(function (p) { fd.append(p[0], p[1]); });
        if (useDrawer && i === lines.length - 1) {
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
        }
        function post(body) {
          return fetch(url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: body
          }).then(function (r) { return r.json(); });
        }
        return post(fd).then(function (res) {
          // Lehnt der Shop die SVG-Datei ab, ohne Vektordatei erneut senden
          if (res.status && vectorProps.length && !/menge|quantity|verfügbar|available|sold out|ausverkauft/i.test(res.description || '')) {
            console.warn('Vektordatei abgelehnt', res.description || res.message);
            vectorProps.forEach(function (k) { fd.delete(k); });
            props = props.filter(function (p) { return vectorProps.indexOf(p[0]) === -1; });
            vectorProps = [];
            return post(fd);
          }
          return res;
        }).then(function (res) {
          if (res.status) {
            console.error('cart/add', line.size, line.qty, res);
            // Nachsehen, ob die Größe trotz Meldung im Warenkorb gelandet ist
            return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var inCart = 0, mine = 0;
              (cart.items || []).forEach(function (it) {
                if (it.variant_id !== line.variant.id) return;
                inCart += it.quantity;
                if (it.properties && (it.properties['_Design-ID'] === designId)) mine += it.quantity;
              });
              console.warn('Warenkorb', line.size, 'gesamt', inCart, 'dieses Design', mine);
              if (mine >= line.qty) { added.push({ quantity: mine, variant_title: line.variant.title }); return; }
              var msg = res.description || res.message || 'Fehler';
              if (/menge|quantity|verfügbar|available/i.test(msg)) {
                msg = 'Der Shop lässt gerade nicht mehr zu' + (mine ? ' (nur ' + mine + ' von ' + line.qty + ' kamen in den Warenkorb)' : '') + '. Meldung vom Shop: ' + msg;
              }
              throw new Error((line.size ? line.size + ': ' : '') + msg);
            });
          }
          last = res;
          added.push(res);
          // Weitere Größen: schon hochgeladene Dateien als Link mitgeben statt erneut hochladen
          if (res.properties) {
            props = props.map(function (p) {
              if (!(p[1] instanceof File)) return p;
              var key = p[0].slice(11, -1);
              var url = res.properties[key];
              return typeof url === 'string' && /^https?:/.test(url) ? [p[0], url] : p;
            });
            vectorProps = vectorProps.filter(function (k) {
              return props.some(function (p) { return p[0] === k && p[1] instanceof File; });
            });
          }
        });
      });
    });

    // Aufpreis für weitere Motive als eigene Position (je Stück und Motiv)
    if (extra && this.extraMotifVariant) {
      chain = chain.then(function () {
        var fd = new FormData();
        fd.set('id', self.extraMotifVariant);
        fd.set('quantity', String(pieces * extra));
        fd.append('properties[_Design-ID]', designId);
        fd.append('properties[Für]', self.data.title + ', ' + pieces + ' Stück × ' + extra + (extra === 1 ? ' weiteres Motiv' : ' weitere Motive'));
        if (useDrawer) {
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
        }
        return fetch(url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          // Fehlt das Aufpreis-Produkt im Shop, bleibt die Bestellung trotzdem möglich (Motive stehen an der Position)
          if (res.status) { console.warn('Aufpreis Motive', res.description || res.message); return; }
          if (useDrawer) last = res;
        }).catch(function (e) { console.warn('Aufpreis Motive', e); });
      });
    }

    // Datei-Check bzw. Logo-Überarbeitung als eigene Position, einmal je Design
    if (serviceVariant) {
      chain = chain.then(function () {
        var fd = new FormData();
        fd.set('id', serviceVariant);
        fd.set('quantity', '1');
        fd.append('properties[_Design-ID]', designId);
        fd.append('properties[Für]', self.data.title + ', ' + pieces + ' Stück');
        if (useDrawer) {
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
        }
        return fetch(url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          // Fehlt das Produkt im Shop, steht der Datei-Check trotzdem an der Position
          if (res.status) { console.warn('Datei-Check', res.description || res.message); return; }
          if (useDrawer) last = res;
        }).catch(function (e) { console.warn('Datei-Check', e); });
      });
    }

    chain.then(function () {
      // Kam die letzte Antwort ohne Warenkorb-Abschnitte zurück, holen wir sie nach
      if (useDrawer && !(last && last.sections)) {
        return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
          last = { sections: s };
        }, function () {});
      }
    }).then(function () {
      var res = last;
      if (useDrawer && res && res.sections) {
        drawer.classList.remove('is-empty');
        // Inhalt aktualisieren, Schublade aber zu lassen (Kunde gestaltet weiter)
        drawer.open = function () {};
        drawer.renderContents(res);
        setTimeout(function () { delete drawer.open; }, 60);
        // Bestand im Raster um das gerade Bestellte senken
        lines.forEach(function (l) {
          if (l.variant && typeof l.variant.stock === 'number') {
            l.variant.stock = Math.max(0, l.variant.stock - (l.qty || 1));
            if (!l.variant.stock) l.variant.available = false;
          }
        });
        self.renderSizes();
        self.addedToast(lines, drawer);
      } else {
        var img = $(self.root, '[data-pd-added-img]');
        if (firstPreview) { img.src = URL.createObjectURL(firstPreview); img.hidden = false; } else img.hidden = true;
        $(self.root, '[data-pd-added-text]').textContent = added.map(function (r) {
          return (r.quantity || 1) + ' × ' + (r.variant_title || r.product_title || self.data.title);
        }).join(', ');
        self.openModal('added');
      }
    }).catch(function (e) {
      // Was schon im Warenkorb liegt, auf 0 setzen, damit nichts doppelt bestellt wird
      if (added.length && self.sizeQty) {
        lines.slice(0, added.length).forEach(function (l) { if (l.size) self.setSizeQty(l.size, 0); });
      }
      var msg = 'Das hat nicht geklappt: ' + (e && e.message ? e.message : 'unbekannter Fehler') + '.';
      if (added.length) msg += ' ' + added.length + ' von ' + lines.length + ' Größen liegen schon im Warenkorb.';
      else msg += ' Bitte versuche es noch einmal.';
      self.formError(msg);
    }).then(function () {
      btn.disabled = false;
      busy.hidden = true;
    });
  };

  /* ---------- Bedienelemente ---------- */

  P.bindUi = function () {
    var self = this;
    var root = this.root;

    $$(root, '[data-pd-tool]').forEach(function (b) {
      b.addEventListener('click', function () { self.openTool(b.dataset.pdTool); });
    });
    $(root, '[data-pd-flyout-close]').addEventListener('click', function () { self.closeTool(); });
    $$(root, '[data-pd-fc-input]').forEach(function (i) {
      i.addEventListener('change', function () { self.setService(i.checked ? 'check' : ''); });
    });
    $$(root, '[data-pd-rw-input]').forEach(function (i) {
      i.addEventListener('change', function () { self.setService(i.checked ? 'rework' : ''); });
    });
    var fcYes = $(root, '[data-pd-fc-yes]'), fcNo = $(root, '[data-pd-fc-no]'), rwYes = $(root, '[data-pd-rw-yes]');
    if (fcYes) fcYes.addEventListener('click', function () { self.answerFileCheck('check'); });
    if (rwYes) rwYes.addEventListener('click', function () { self.answerFileCheck('rework'); });
    if (fcNo) fcNo.addEventListener('click', function () { self.answerFileCheck(''); });

    $(root, '[data-pd-undo]').addEventListener('click', function () { self.stepHistory(-1); });
    $(root, '[data-pd-redo]').addEventListener('click', function () { self.stepHistory(1); });

    // Text
    var tInput = $(root, '[data-pd-text-input]');
    $(root, '[data-pd-text-add]').addEventListener('click', function () {
      var t = self.activeText();
      if (t) {
        // Neuer Text: Auswahl lösen, Feld leeren, Tippen erzeugt den nächsten Text
        self.canvas.discardActiveObject();
        self.canvas.requestRenderAll();
        tInput.value = '';
        tInput.focus();
        return;
      }
      self.addText(tInput.value.trim() || 'Dein Text');
    });
    // Text erscheint beim Tippen sofort auf dem Produkt
    tInput.addEventListener('input', function () {
      var t = self.activeText();
      if (!t) {
        if (self.creatingText || !tInput.value.trim()) return;
        self.creatingText = true;
        self.addText(tInput.value, function (nt) {
          self.creatingText = false;
          if (tInput.value !== nt.text) {
            nt.set('text', tInput.value || ' ');
            nt.initDimensions();
            self.fitTextWidth(nt);
            nt.setCoords();
            self.canvas.requestRenderAll();
          }
        });
        return;
      }
      t.set('text', tInput.value || ' ');
      if (t.pdCurve) applyCurve(t);
      else { t.initDimensions(); t.setCoords(); }
      self.fitTextWidth(t);
      self.constrain(t);
      self.checkOverlap(true);
      self.canvas.requestRenderAll();
      clearTimeout(self.textTimer);
      self.textTimer = setTimeout(function () { self.pushHistory(); self.persist(); }, 400);
    });
    // Upload
    var file = $(root, '[data-pd-file]');
    file.addEventListener('change', function () { self.handleFiles(file.files); file.value = ''; });
    var dz = $(root, '[data-pd-dropzone]');
    ['dragenter', 'dragover'].forEach(function (t) {
      dz.addEventListener(t, function (e) { e.preventDefault(); dz.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      dz.addEventListener(t, function (e) { e.preventDefault(); dz.classList.remove('is-over'); });
    });
    dz.addEventListener('drop', function (e) { if (e.dataTransfer) self.handleFiles(e.dataTransfer.files); });

    // Motive
    $$(root, '[data-pd-motif]').forEach(function (b) {
      b.addEventListener('click', function () { self.addMotif(b.dataset.pdMotif, parseInt(b.dataset.pdMotifW, 10)); });
    });

    // Schwebende Leiste
    var tb = $(root, '[data-pd-toolbar]');
    $$(tb, '[data-pd-pop]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); self.openPop(b.dataset.pdPop); });
    });
    document.addEventListener('click', function (e) {
      if (self.openPopName && !e.target.closest('[data-pd-toolbar]')) self.openPop(null);
    });
    $(tb, '[data-pd-bold]').addEventListener('click', function () {
      var t = self.activeText(); if (!t) return;
      var w = t.fontWeight === 'bold' ? 'normal' : 'bold';
      loadFont(t.fontFamily, w, t.fontStyle).then(function () { self.setTextProp({ fontWeight: w }); });
    });
    $(tb, '[data-pd-italic]').addEventListener('click', function () {
      var t = self.activeText(); if (!t) return;
      var st = t.fontStyle === 'italic' ? 'normal' : 'italic';
      loadFont(t.fontFamily, t.fontWeight, st).then(function () { self.setTextProp({ fontStyle: st }); });
    });
    $(tb, '[data-pd-underline]').addEventListener('click', function () {
      var t = self.activeText(); if (!t) return;
      self.setTextProp({ underline: !t.underline });
    });
    $(tb, '[data-pd-align-cycle]').addEventListener('click', function () {
      var t = self.activeText(); if (!t) return;
      var next = { left: 'center', center: 'right', right: 'left' }[t.textAlign] || 'center';
      self.setTextProp({ textAlign: next });
    });
    var sizeRange = $(tb, '[data-pd-size-range]');
    sizeRange.addEventListener('input', function () { self.setObjSize(+sizeRange.value); });
    sizeRange.addEventListener('change', function () {
      var o = self.canvas.getActiveObject();
      if (o) self.canvas.fire('object:modified', { target: o });
    });
    var strokeW = $(tb, '[data-pd-stroke-width]');
    strokeW.addEventListener('input', function () {
      var t = self.activeText(); if (!t) return;
      var w = +strokeW.value;
      if (w > 0 && !t.stroke) t.set({ stroke: '#000000', paintFirst: 'stroke', strokeLineJoin: 'round' });
      t.set('strokeWidth', w);
      if (t.pdCurve) applyCurve(t); else { t.initDimensions(); t.setCoords(); }
      self.constrain(t);
      self.canvas.requestRenderAll();
    });
    strokeW.addEventListener('change', function () { var t = self.activeText(); if (t) self.changed({ target: t }); });
    var curve = $(tb, '[data-pd-curve]');
    curve.addEventListener('input', function () {
      var t = self.activeText(); if (!t) return;
      var v = +curve.value;
      if (Math.abs(v) < 4) v = 0;
      t.pdCurve = v;
      applyCurve(t);
      self.constrain(t);
      self.canvas.requestRenderAll();
    });
    curve.addEventListener('change', function () { var t = self.activeText(); if (t) self.changed({ target: t }); });
    $(tb, '[data-pd-curve-reset]').addEventListener('click', function () {
      var t = self.activeText(); if (!t) return;
      curve.value = 0;
      t.pdCurve = 0;
      self.setTextProp({});
    });

    // Aktionen für das ausgewählte Objekt
    $$(root, '[data-pd-obj]').forEach(function (b) {
      b.addEventListener('click', function () {
        var o = self.canvas.getActiveObject();
        if (!o) return;
        var act = b.dataset.pdObj;
        var pa = self.printArea();
        var mod = true;
        if (act === 'delete') { self.removeObject(o); return; }
        if (act === 'removebg') { self.removeBackground(o, { inner: true }); return; }
        if (act === 'duplicate') { if (o.type !== 'activeSelection') self.duplicate(o); return; }
        if (act === 'selectgroup') { self.openPop(null); self.selectGroup(o); return; }
        var list = self.members(o), ur = self.unionRect(list);
        if (act === 'center') self.shiftList(list, pa.x + pa.w / 2 - (ur.left + ur.width / 2), 0);
        else if (act === 'vcenter') self.shiftList(list, 0, pa.y + pa.h / 2 - (ur.top + ur.height / 2));
        else if (act === 'flip') o.set('flipX', !o.flipX);
        else if (act === 'up') o.bringForward();
        else if (act === 'down') o.sendBackwards();
        else mod = false;
        o.setCoords();
        if (mod) self.canvas.fire('object:modified', { target: o });
        self.canvas.requestRenderAll();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { self.closeModal(); self.openPop(null); }
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      var o = self.canvas.getActiveObject();
      if ((e.ctrlKey || e.metaKey) && lc(e.key) === 'z') { e.preventDefault(); self.stepHistory(e.shiftKey ? 1 : -1); return; }
      if (!o || o.isEditing) return;
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); self.removeObject(o); return; }
      var step = e.shiftKey ? 10 : 1;
      var dx = { ArrowLeft: -step, ArrowRight: step }[e.key] || 0;
      var dy = { ArrowUp: -step, ArrowDown: step }[e.key] || 0;
      if (self.viewRot && (dx || dy)) {
        // Pfeile wirken in Bildschirmrichtung, auch bei gedrehter Ansicht
        var ra = -self.viewRot * Math.PI / 180, rc = Math.round(Math.cos(ra)), rs = Math.round(Math.sin(ra));
        var ndx = dx * rc - dy * rs;
        dy = dx * rs + dy * rc;
        dx = ndx;
      }
      if (dx || dy) {
        e.preventDefault();
        var list = self.members(o);
        self.shiftList(list, dx, dy);
        self.keepInside(list);
        self.checkOverlap(true);
        self.canvas.requestRenderAll();
        clearTimeout(self.nudgeTimer);
        self.nudgeTimer = setTimeout(function () { self.canvas.fire('object:modified', { target: o }); }, 300);
      }
    });

    // Zoom
    var range = $(root, '[data-pd-zoom-range]');
    range.addEventListener('input', function () { self.zoom = range.value / 100; self.layout(); });
    $$(root, '[data-pd-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(100, Math.min(250, parseInt(range.value, 10) + parseInt(b.dataset.pdZoom, 10) * 25));
        range.value = v; self.zoom = v / 100; self.layout();
      });
    });

    // Ansicht drehen
    $$(root, '[data-pd-rot]').forEach(function (b) {
      b.addEventListener('click', function () { self.rotateView(parseInt(b.dataset.pdRot, 10)); });
    });
    var rotReset = $(root, '[data-pd-rot-reset]');
    if (rotReset) rotReset.addEventListener('click', function () { self.rotateView(-self.viewRot); });
    this.updateRotateUi();

    // Teilen
    $(root, '[data-pd-share]').addEventListener('click', function () { self.shareDesign(); });

    // Dialoge
    $$(root, '[data-pd-open]').forEach(function (b) {
      b.addEventListener('click', function () { self.openModal(b.dataset.pdOpen); });
    });

    // Produktwechsel: Design vorher sichern
    $$(root, '[data-pd-product-link]').forEach(function (a) {
      a.addEventListener('click', function () {
        clearTimeout(self.persistTimer);
        self.saveView();
        self.writeStore();
      });
    });

    this.form.addEventListener('submit', function (e) { self.submit(e); });

    // Summe aus der Staffelpreis-Tabelle neben den Button schreiben
    root.addEventListener('qbp:change', function (e) {
      if (!e.detail) return;
      self.qbpTotal = e.detail.total;
      self.renderTotal();
    });
    var rcb = $(root, '[data-pd-rights-input]');
    if (rcb) rcb.addEventListener('change', function () { if (rcb.checked) $(root, '[data-pd-rights-error]').hidden = true; });
  };

  /* ---------- Ansichten nur zum Anschauen (z. B. Vorderseite ohne Druck) ---------- */

  P.firstEditable = function () {
    for (var i = 0; i < this.views.length; i++) if (!this.views[i].readonly) return i;
    return -1;
  };

  P.applyReadonly = function () {
    var ro = !!(this.view() && this.view().readonly);
    this.root.classList.toggle('pd--readonly', ro);
    var vp = $(this.root, '[data-pd-viewport]');
    var note = $(this.root, '[data-pd-readonly-note]');
    if (!note && vp) {
      var self = this;
      note = document.createElement('div');
      note.className = 'pd__readonly-note';
      note.setAttribute('data-pd-readonly-note', '');
      note.innerHTML = '<span>Diese Seite wird nicht bedruckt.</span><button type="button" class="pd__readonly-go"></button>';
      note.querySelector('button').addEventListener('click', function () {
        var i = self.firstEditable();
        if (i >= 0) self.showView(i);
      });
      vp.appendChild(note);
    }
    if (note) {
      var i = this.firstEditable();
      var go = note.querySelector('button');
      go.textContent = i >= 0 ? this.views[i].name + ' gestalten' : '';
      go.hidden = i < 0;
      note.hidden = !ro;
    }
    if (this.updateSetup) this.updateSetup();
  };

  /* ---------- Einstellmodus: Druckbereich mit der Maus festlegen (?druckbereich=1) ---------- */

  P.setupMode = function () {
    var self = this;
    var vp = $(this.root, '[data-pd-viewport]');
    var area = $(this.root, '[data-pd-printarea]');
    if (!vp || !area) return;
    this.viewRot = 0;
    this.root.classList.add('pd--setup');
    var panel = document.createElement('div');
    panel.className = 'pd__setup';
    panel.innerHTML =
      '<strong>Einstellmodus Druckbereich</strong>' +
      '<p class="pd__setup-name" data-s-name></p>' +
      '<div class="pd__setup-cm">' +
        '<label>Druckbreite (cm)<input type="number" step="0.1" min="0.1" data-s-cmw></label>' +
        '<label>Druckhöhe (cm)<input type="number" step="0.1" min="0.1" data-s-cmh></label>' +
      '</div>' +
      '<dl class="pd__setup-vals">' +
        '<dt>Lage links (%)</dt><dd data-s-x></dd>' +
        '<dt>Lage oben (%)</dt><dd data-s-y></dd>' +
        '<dt>Breite im Bild (%)</dt><dd data-s-w></dd>' +
      '</dl>' +
      '<small>Rechteck verschieben, an der Ecke unten rechts die Größe ändern. Dann die Zahlen bei der Druckseite im Admin eintragen.</small>';
    this.root.appendChild(panel);
    var handle = document.createElement('span');
    handle.className = 'pd__setup-handle';
    area.appendChild(handle);
    var cmw = panel.querySelector('[data-s-cmw]'), cmh = panel.querySelector('[data-s-cmh]');
    function r1(n) { return Math.round(n * 10) / 10; }
    function de(n) { return String(r1(n)).replace('.', ','); }
    this.updateSetup = function () {
      var v = self.view();
      panel.querySelector('[data-s-name]').textContent = 'Seite: ' + v.name + (v.readonly ? ' (nur Ansicht, nicht bedruckbar)' : '');
      panel.querySelector('[data-s-x]').textContent = v.readonly ? '' : de(v.x);
      panel.querySelector('[data-s-y]').textContent = v.readonly ? '' : de(v.y);
      panel.querySelector('[data-s-w]').textContent = v.readonly ? '' : de(v.w);
      if (document.activeElement !== cmw) cmw.value = r1(v.cm_w);
      if (document.activeElement !== cmh) cmh.value = r1(v.cm_h);
      cmw.disabled = cmh.disabled = v.readonly;
    };
    function onCm() {
      var v = self.view();
      var a = parseFloat(String(cmw.value).replace(',', '.')), b = parseFloat(String(cmh.value).replace(',', '.'));
      if (a > 0) v.cm_w = a;
      if (b > 0) v.cm_h = b;
      self.layout();
      self.updateSetup();
    }
    cmw.addEventListener('input', onCm);
    cmh.addEventListener('input', onCm);
    function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
    area.addEventListener('pointerdown', function (e) {
      var v = self.view();
      if (v.readonly) return;
      e.preventDefault();
      var rect = $(self.root, '[data-pd-mockup]').getBoundingClientRect();
      var resize = e.target === handle;
      var sx = e.clientX, sy = e.clientY, ox = v.x, oy = v.y, ow = v.w;
      area.setPointerCapture(e.pointerId);
      function hPct() { return v.w * v.cm_h / v.cm_w * self.ratioFor(v); }
      function move(ev) {
        var dx = (ev.clientX - sx) / rect.width * 100, dy = (ev.clientY - sy) / rect.height * 100;
        if (resize) v.w = clamp(ow + dx, 2, 100 - v.x);
        else {
          v.x = clamp(ox + dx, 0, Math.max(0, 100 - v.w));
          v.y = clamp(oy + dy, 0, Math.max(0, 100 - hPct()));
        }
        self.layout();
        self.updateSetup();
      }
      function up() {
        area.removeEventListener('pointermove', move);
        area.removeEventListener('pointerup', up);
        area.removeEventListener('pointercancel', up);
      }
      area.addEventListener('pointermove', move);
      area.addEventListener('pointerup', up);
      area.addEventListener('pointercancel', up);
    });
    this.layout();
    this.updateSetup();
  };

  (function () {
    var show = P.showView;
    P.showView = function () {
      var r = show.apply(this, arguments);
      this.applyReadonly();
      return r;
    };
    // Wird auf einer Nur-Ansicht etwas hinzugefügt, zuerst zur Druckseite wechseln
    ['addObject', 'addText', 'addTemplate', 'addUpload', 'addMotif', 'addLibMotif'].forEach(function (name) {
      var orig = P[name];
      if (!orig) return;
      P[name] = function () {
        var self = this, args = arguments;
        if (!(self.view() && self.view().readonly)) return orig.apply(self, args);
        var i = self.firstEditable();
        if (i < 0) return;
        self.showView(i);
        (function go() {
          if (self.loading) return setTimeout(go, 30);
          orig.apply(self, args);
        })();
      };
    });
  })();

  function boot() {
    whenFabric(function () {
      document.querySelectorAll('[data-pd]').forEach(function (root) {
        if (root.dataset.pdInit) return;
        root.dataset.pdInit = '1';
        try {
          root.pdDesigner = new Designer(root);
          if (/[?&]druckbereich=/.test(location.search)) root.pdDesigner.setupMode();
        } catch (e) { console.error('Produkt-Designer', e); }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
